import React, { useState, useEffect, useCallback } from 'react';
import { useAdmin } from '../context/AdminContext';
import { jsPDF } from 'jspdf';
import { formatFecha } from '../utils/fecha';
import { ModalGenerarProyecciones } from '../components/ModalGenerarProyecciones';

import { API } from '../config/api';
import { apiFetch } from '../config/http';

// ── Modal eliminar ─────────────────────────────────────────────────────────────
function ModalEliminar({ titulo, descripcion, onConfirm, onCancel }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.35)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
      <div style={{ background:'#fff', borderRadius:'14px', padding:'28px', width:'380px' }}>
        <div style={{ width:'52px', height:'52px', background:'#FCEBEB', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="#A32D2D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h3 style={{ textAlign:'center', fontSize:'16px', fontWeight:'700', color:'#1a1a1a', margin:'0 0 8px' }}>{titulo}</h3>
        <p style={{ textAlign:'center', fontSize:'13px', color:'#666', margin:'0 0 20px', lineHeight:'1.5' }}>
          ¿Eliminar permanentemente <strong>{descripcion}</strong>?<br/>
          Esta acción <strong>no se puede deshacer</strong> y eliminará todas las líneas, hitos y presupuesto asociados.
        </p>
        <div style={{ display:'flex', justifyContent:'flex-end', gap:'10px' }}>
          <button onClick={onCancel} style={{ padding:'8px 20px', border:'1px solid #e0e0e0', borderRadius:'8px', background:'#fff', cursor:'pointer', fontSize:'13px' }}>Cancelar</button>
          <button onClick={onConfirm} style={{ padding:'8px 20px', background:'#A32D2D', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>Sí, eliminar</button>
        </div>
      </div>
    </div>
  );
}


// ── Modal confirmar aprobación + datos del proyecto (OC, exoneración) ─────────
function ModalAprobar({ oferta, proyectoPrevio, cargandoPrevio, onConfirm, onCancel, aprobando }) {
  const [orden_compra,       setOrdenCompra]       = useState('');
  const [exonerado,          setExonerado]         = useState(false);
  const [codigo_exoneracion, setCodigoExoneracion] = useState('');
  const [fecha_autorizacion, setFechaAutorizacion] = useState('');

  // Pre-carga valores si el proyecto ya existe
  useEffect(() => {
    if (proyectoPrevio) {
      setOrdenCompra(proyectoPrevio.orden_compra || '');
      setExonerado(!!proyectoPrevio.exonerado);
      setCodigoExoneracion(proyectoPrevio.codigo_exoneracion || '');
      setFechaAutorizacion(proyectoPrevio.fecha_autorizacion ? String(proyectoPrevio.fecha_autorizacion).split('T')[0] : '');
    } else {
      setOrdenCompra(''); setExonerado(false); setCodigoExoneracion(''); setFechaAutorizacion('');
    }
  }, [proyectoPrevio?.id]);

  const hayDatos = (orden_compra && orden_compra.trim())
                 || exonerado
                 || (codigo_exoneracion && codigo_exoneracion.trim())
                 || fecha_autorizacion;

  const labelStyle = { fontSize:'11px', color:'#666', fontWeight:'500', display:'block', marginBottom:'4px' };
  const inputS     = { padding:'8px 12px', border:'1px solid #e0e0e0', borderRadius:'8px', fontSize:'13px', outline:'none', width:'100%', boxSizing:'border-box', fontFamily:'Segoe UI, sans-serif' };

  const confirmarSinDatos = () => {
    if (!window.confirm('¿Aprobar sin OC ni código de exoneración?\n\nPodrás completar estos datos después desde el módulo de Proyectos.')) return;
    onConfirm({ orden_compra: '', exonerado: false, codigo_exoneracion: '', fecha_autorizacion: '' });
  };

  const confirmarConDatos = () => {
    onConfirm({
      orden_compra:       (orden_compra || '').trim(),
      exonerado:          !!exonerado,
      codigo_exoneracion: (codigo_exoneracion || '').trim(),
      fecha_autorizacion: fecha_autorizacion || ''
    });
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.35)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
      <div style={{ background:'#fff', borderRadius:'14px', padding:'28px', width:'480px', maxHeight:'88vh', overflowY:'auto' }}>
        <div style={{ width:'52px', height:'52px', background:'#eaf3de', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5 13l4 4L19 7" stroke="#3B6D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h3 style={{ textAlign:'center', fontSize:'16px', fontWeight:'700', color:'#1a1a1a', margin:'0 0 6px' }}>Aprobar oferta</h3>
        <p style={{ textAlign:'center', fontSize:'13px', color:'#666', margin:'0 0 4px', lineHeight:'1.5' }}>
          <strong>{oferta?.numero_ofs}</strong> — {oferta?.nombre_proyecto}
        </p>
        <p style={{ textAlign:'center', fontSize:'11px', color:'#888', margin:'0 0 18px' }}>
          Se creará o actualizará el proyecto con estado <strong>Activo</strong>.
        </p>

        <div style={{ background:'#fafafa', border:'1px solid #eee', borderRadius:'10px', padding:'14px 16px', marginBottom:'18px' }}>
          <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'10px' }}>
            Datos del proyecto (opcionales)
            {cargandoPrevio && <span style={{ marginLeft:'8px', color:'#aaa', fontWeight:'400', textTransform:'none' }}>cargando…</span>}
          </div>

          <div style={{ marginBottom:'12px' }}>
            <label style={labelStyle}>Orden de compra (OC)</label>
            <input type="text" value={orden_compra} onChange={e => setOrdenCompra(e.target.value)}
              placeholder="Ingrese N° de OC si aplica" style={inputS} />
          </div>

          <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom: exonerado ? '12px' : '0' }}>
            <label style={{ position:'relative', display:'inline-block', width:'34px', height:'19px' }}>
              <input type="checkbox" checked={exonerado} onChange={e => setExonerado(e.target.checked)}
                style={{ opacity:0, width:0, height:0 }} />
              <span style={{ position:'absolute', cursor:'pointer', inset:0, background: exonerado ? '#87B749' : '#ccc', borderRadius:'19px', transition:'.2s' }}>
                <span style={{ position:'absolute', height:'13px', width:'13px', left: exonerado ? '18px' : '3px', bottom:'3px', background:'#fff', borderRadius:'50%', transition:'.2s' }} />
              </span>
            </label>
            <span style={{ fontSize:'12px', color: exonerado ? '#3B6D11' : '#666', fontWeight:'500' }}>
              {exonerado ? 'Exoneración de IVA activa' : 'Sin exoneración de IVA'}
            </span>
          </div>

          {exonerado && (
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>
              <div>
                <label style={labelStyle}>Código de exoneración</label>
                <input type="text" value={codigo_exoneracion} onChange={e => setCodigoExoneracion(e.target.value)}
                  placeholder="Ej: EX-2026-..." style={inputS} />
              </div>
              <div>
                <label style={labelStyle}>Fecha de autorización</label>
                <input type="date" value={fecha_autorizacion} onChange={e => setFechaAutorizacion(e.target.value)}
                  style={inputS} />
              </div>
            </div>
          )}
        </div>

        <div style={{ display:'flex', justifyContent:'flex-end', gap:'8px', flexWrap:'wrap' }}>
          <button onClick={onCancel} disabled={aprobando}
            style={{ padding:'8px 16px', border:'1px solid #e0e0e0', borderRadius:'8px', background:'#fff', cursor: aprobando ? 'not-allowed' : 'pointer', fontSize:'13px', opacity: aprobando ? 0.6 : 1 }}>
            Cancelar
          </button>
          <button onClick={confirmarSinDatos} disabled={aprobando}
            style={{ padding:'8px 16px', border:'1px solid #d8d8d8', borderRadius:'8px', background:'#f4f4f4', color:'#555', cursor: aprobando ? 'not-allowed' : 'pointer', fontSize:'13px', opacity: aprobando ? 0.6 : 1 }}>
            Aprobar sin OC ni código
          </button>
          <button onClick={confirmarConDatos} disabled={aprobando || !hayDatos}
            title={!hayDatos ? 'Complete al menos un campo para habilitar' : ''}
            style={{ padding:'8px 18px', background: (aprobando || !hayDatos) ? '#a0c07a' : '#3B6D11', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor: (aprobando || !hayDatos) ? 'not-allowed' : 'pointer' }}>
            {aprobando ? 'Aprobando…' : 'Aprobar y guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Constantes ─────────────────────────────────────────────────────────────────
const PROVINCIAS = ['San José','Alajuela','Cartago','Heredia','Guanacaste','Puntarenas','Limón'];
const EMPRESAS   = ['JyA Conusa','Cuenta Personal (JCNS)'];
const ESTADOS         = ['Borrador','Enviada','Aprobada','Rechazada'];
const ESTADOS_FILTRO  = ['Borrador','Enviada','Aprobada','Rechazada','Vencida'];

const SERVICIOS_CATS = [
  { cat: 'Topografía y Catastro',    items: ['Levantamiento curvas de nivel','Levantamiento de linderos','Planos de catastro','Topografía de construcción','Replanteo topográfico'] },
  { cat: 'Estudios Preliminares',    items: ['Consultas disponibilidad de servicios','Estudio Hidrológico','Estudio Impacto Vial','Análisis de anteproyecto','Análisis de master plan','Due diligence','Uso de Suelo','Estudios de factibilidad técnica'] },
  { cat: 'Diseño y Planos',          items: ['Movimiento de tierra','Alcantarillado pluvial','Alcantarillado sanitario','Redes de agua potable','Red primaria de riego','Red primaria de incendio','Red distribución de gas','Diseño de pavimentos','Diseño Vial','Sistemas retención pluvial','Estaciones de bombeo','Especificaciones técnicas'] },
  { cat: 'Trámites y Permisos',      items: ['Trámites APC','Permisos municipalidad','Permiso desfogue pluvial'] },
  { cat: 'Fase Constructiva',        items: ['Inspección de obras','Dirección técnica de obra','REC'] },
  { cat: 'Planeamiento',             items: ['Plan maestro infraestructura','Modelo desarrollo inmobiliario'] },
  { cat: 'Otros',                    items: ['Auditoría de diseños','Fiscalización de inversiones','Coordinación multidisciplinaria','Asesoría técnica','Gerencia de proyecto'] },
];

// Dado un array de servicios seleccionados, retorna las categorías únicas a las que pertenecen
const categoriasDeServicios = (servicios) => {
  if (!servicios || servicios.length === 0) return [];
  const cats = new Set();
  servicios.forEach(srv => {
    const match = SERVICIOS_CATS.find(c => c.items.includes(srv));
    if (match) cats.add(match.cat);
  });
  return Array.from(cats);
};

const fmt    = (n) => Number(n || 0).toLocaleString('es-CR', { minimumFractionDigits:2, maximumFractionDigits:2 });
const fmtPct = (n) => Number(n || 0).toFixed(1);

// ── Estilos compartidos ────────────────────────────────────────────────────────
const inputStyle = {
  padding:'8px 12px', border:'1px solid #e0e0e0', borderRadius:'8px',
  fontSize:'13px', outline:'none', width:'100%', boxSizing:'border-box',
  fontFamily:'Segoe UI, sans-serif'
};

const badgeEstado = (estado) => {
  const map = { Borrador:['#F1EFE8','#5F5E5A'], Enviada:['#faeeda','#854F0B'], Aprobada:['#eaf3de','#3B6D11'], Rechazada:['#FCEBEB','#A32D2D'], Vencida:['#e6f1fb','#185FA5'] };
  const [bg, color] = map[estado] || ['#f0f0f0','#555'];
  return <span style={{ display:'inline-block', padding:'2px 10px', borderRadius:99, fontSize:11, fontWeight:500, background:bg, color }}>{estado}</span>;
};

// ── Helpers de forma vacía ─────────────────────────────────────────────────────
const esVencida = (o) => {
  if (!o.fecha_vencimiento) return false;
  if (o.estado !== 'Borrador' && o.estado !== 'Enviada') return false;
  return new Date(o.fecha_vencimiento) < new Date(new Date().toDateString());
};
const estadoEfectivo = (o) => esVencida(o) ? 'Vencida' : o.estado;

const lineaVacia = (n) => ({
  numero_linea:n, descripcion_corta:'', descripcion_larga:'', notas:'',
  monto:'', exonerado:false, es_recurrente:false, unidad:'',
  cotizacion_id:'', tipo_cambio:'', monto_cotizacion_convertido:null,
  hitos:[], presupuesto:[],
  _showPresup:false, _showSubcontrato:false, _showHitos:false
});
const hitoVacio   = ()  => ({ nombre_hito:'', porcentaje:'' });
const presupVacio = (n) => ({ numero_item:n, descripcion:'', precio_unitario:'', unidad:'', cantidad:1, utilidad_pct:30 });

const formVacio = {
  numero_ofs:'', nombre_proyecto:'', descripcion_general:'',
  cliente_id:'', nombre_contacto:'', telefono_contacto:'', correo_contacto:'',
  tipo_servicio_oferta:'', moneda:'Dólares',
  provincia:'San José', canton:'', distrito:'', direccion:'',
  facturar_con:'JyA Conusa', estado:'Borrador', condiciones_generales:'',
  fecha_oferta:'', vigencia_dias:30, fecha_vencimiento:'',
  servicios:[], lineas:[lineaVacia(1), lineaVacia(2)]
};

// ── Helpers UI del formulario ──────────────────────────────────────────────────
const seccion = (label) => (
  <div style={{ gridColumn:'1/-1', fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', padding:'8px 0 6px', borderBottom:'2px solid #e8e8e8', marginTop:'8px' }}>{label}</div>
);

const campoVer = (label, valor) => (
  <div>
    <div style={{ fontSize:'10px', color:'#aaa', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'3px' }}>{label}</div>
    <div style={{ fontSize:'13px', color: valor ? '#012E40' : '#ccc', fontWeight: valor ? '500' : '400' }}>{valor || '—'}</div>
  </div>
);

const hrSep = () => <hr style={{ border:'none', borderTop:'1px solid #f0f0f0', margin:'14px 0' }}/>;

// ── Generador de PDF ───────────────────────────────────────────────────────────
const LOGO_URL = '/logo_infra.png'; // Logo en public/

// i18n del PDF — agregar idiomas nuevos aquí
const I18N = {
  es: {
    titulo:             'OFERTA DE SERVICIOS PROFESIONALES',
    cliente:            'CLIENTE',
    cedula:             'CÉDULA',
    contacto:           'CONTACTO',
    correo:             'CORREO',
    proyecto:           'PROYECTO',
    ofs:                'OFS',
    fecha:              'FECHA',
    tipologia:          'TIPOLOGÍA',
    vigencia:           'VIGENCIA',
    ubicacion:          'UBICACIÓN',
    serviciosCotizados: 'SERVICIOS COTIZADOS',
    honorarios:         'HONORARIOS PROFESIONALES Y PLAN DE PAGOS',
    item:               'ÍTEM',
    descripcion:        'DESCRIPCIÓN',
    costoIva:           'COSTO + IVA',
    terminos:           'TÉRMINOS DE PAGO',
    comentarios:        'COMENTARIOS',
    iva:                '+IVA 13%',
    exonerado:          'Exonerado',
    masIva:             ' +IVA',
    director:           'Director de Operaciones',
    clienteFirma:       'Cliente',
    footerEmpresa:      'Infra Design — Consultoría de Ingeniería Civil',
    pagina:             (n, t) => `Página ${n} de ${t}`,
    porUnidad:          (u) => `Por ${u}`,
    diasVigencia:       (d) => `${d} días`,
    vence:              (f) => `Vence: ${f}`,
    dias:               ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'],
    meses:              ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'],
    fmtFecha:           (d, meses, dias) => `${dias[d.getUTCDay()]}, ${d.getUTCDate()} de ${meses[d.getUTCMonth()]} de ${d.getUTCFullYear()}`,
  },
  en: {
    titulo:             'PROFESSIONAL SERVICES PROPOSAL',
    cliente:            'CLIENT',
    cedula:             'TAX ID',
    contacto:           'CONTACT',
    correo:             'EMAIL',
    proyecto:           'PROJECT',
    ofs:                'PROPOSAL #',
    fecha:              'DATE',
    tipologia:          'SERVICE TYPE',
    vigencia:           'VALIDITY',
    ubicacion:          'LOCATION',
    serviciosCotizados: 'QUOTED SERVICES',
    honorarios:         'PROFESSIONAL FEES AND PAYMENT SCHEDULE',
    item:               'ITEM',
    descripcion:        'DESCRIPTION',
    costoIva:           'COST + VAT',
    terminos:           'PAYMENT TERMS',
    comentarios:        'COMMENTS',
    iva:                '+VAT 13%',
    exonerado:          'Exempt',
    masIva:             ' +VAT',
    director:           'Operations Director',
    clienteFirma:       'Client',
    footerEmpresa:      'Infra Design — Civil Engineering Consultancy',
    pagina:             (n, t) => `Page ${n} of ${t}`,
    porUnidad:          (u) => `Per ${u}`,
    diasVigencia:       (d) => `${d} days`,
    vence:              (f) => `Expires: ${f}`,
    dias:               ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    meses:              ['January','February','March','April','May','June','July','August','September','October','November','December'],
    fmtFecha:           (d, meses, dias) => `${dias[d.getUTCDay()]}, ${meses[d.getUTCMonth()]} ${d.getUTCDate()}, ${d.getUTCFullYear()}`,
  },
};

// Catálogo de servicios bilingüe — lookup contra oferta.servicios usa siempre item.es
const SERVICIOS_CATALOGO = [
  { cat: { es: 'Topografía y Catastro', en: 'Topography and Cadastral Survey' }, items: [
    { es: 'Levantamiento curvas de nivel y detalles topográficos', en: 'Topographic and contour survey' },
    { es: 'Levantamiento de linderos',                              en: 'Boundary survey' },
    { es: 'Levantamiento detallado de árboles',                     en: 'Detailed tree survey' },
    { es: 'Levantamiento detallado de edificios',                   en: 'Detailed building survey' },
    { es: 'Planos de catastro',                                     en: 'Cadastral plans' },
    { es: 'Replanteo topográficos',                                 en: 'Topographic stakeout' },
    { es: 'Topografía de construcción',                             en: 'Construction surveying' },
  ]},
  { cat: { es: 'Estudios Preliminares', en: 'Preliminary Studies' }, items: [
    { es: 'Consultas de disponibilidad de servicios', en: 'Utility availability inquiries' },
    { es: 'Estudio Hidrológico',                      en: 'Hydrological study' },
    { es: 'Estudio Impacto Vial',                     en: 'Traffic impact study' },
    { es: 'Análisis de anteproyecto',                 en: 'Preliminary design review' },
    { es: 'Análisis de master plan',                  en: 'Master plan review' },
    { es: 'Estudios de factibilidad técnica y de permisos', en: 'Technical and permitting feasibility studies' },
    { es: 'Due diligencie',                           en: 'Due diligence' },
    { es: 'Uso de Suelo',                             en: 'Land use certificate' },
  ]},
  { cat: { es: 'Diseño y Planos Constructivos', en: 'Design and Construction Drawings' }, items: [
    { es: 'Movimiento de tierra',            en: 'Earthworks' },
    { es: 'Alcantarillado pluvial',          en: 'Stormwater sewer' },
    { es: 'Alcantarillado sanitario',        en: 'Sanitary sewer' },
    { es: 'Redes de agua potable',           en: 'Potable water networks' },
    { es: 'Red primaria de riego',           en: 'Primary irrigation network' },
    { es: 'Red primaria de incendio',        en: 'Primary fire protection network' },
    { es: 'Red de distribución de gas',      en: 'Gas distribution network' },
    { es: 'Diseño de pavimentos',            en: 'Pavement design' },
    { es: 'Diseño Vial',                     en: 'Road design' },
    { es: 'Sistemas de retención pluvial',   en: 'Stormwater retention systems' },
    { es: 'Estaciones de bombeo',            en: 'Pump stations' },
    { es: 'Especificaciones técnicas',       en: 'Technical specifications' },
  ]},
  { cat: { es: 'Trámite y Permisos', en: 'Permits and Approvals' }, items: [
    { es: 'Tramites de planos mediante APC',           en: 'Construction plan permits via APC' },
    { es: 'Permisos de construcción ante Municipalidad', en: 'Municipal construction permits' },
    { es: 'Permiso de desfogue pluvial',                en: 'Stormwater discharge permit' },
  ]},
  { cat: { es: 'Fase Constructiva', en: 'Construction Phase' }, items: [
    { es: 'Inspección de obras',                                       en: 'Construction inspection' },
    { es: 'Dirección técnica de obra',                                 en: 'Technical site supervision' },
    { es: 'Responsabilidad de ejecución de la construcción (REC)',     en: 'Construction execution responsibility (REC)' },
  ]},
  { cat: { es: 'Planeamiento', en: 'Planning' }, items: [
    { es: 'Plan maestro de sistemas e infraestructura',     en: 'Infrastructure systems master plan' },
    { es: 'Planeamiento de modelo desarrollo inmobiliario', en: 'Real estate development planning' },
  ]},
  { cat: { es: 'Otros', en: 'Other' }, items: [
    { es: 'Auditoria de diseños',                                 en: 'Design audit' },
    { es: 'Fiscalización de inversiones',                         en: 'Investment oversight' },
    { es: 'Coordinación de proyectos multidisciplinarios',        en: 'Multidisciplinary project coordination' },
    { es: 'Asesoría técnica para desarrollo de proyectos',        en: 'Technical advisory for project development' },
    { es: 'Gerencia de proyecto',                                 en: 'Project management' },
  ]},
];

// Cache global para evitar re-fetch de las TTF en cada PDF de la sesión
let _robotoB64Cache = null;
async function cargarFuentesRoboto(doc) {
  if (!_robotoB64Cache) {
    const files = [
      { url: '/fonts/Roboto-Regular.ttf', style: 'normal' },
      { url: '/fonts/Roboto-Bold.ttf',    style: 'bold'   },
      { url: '/fonts/Roboto-Italic.ttf',  style: 'italic' },
    ];
    const cargadas = await Promise.all(files.map(async f => {
      const resp = await fetch(f.url);
      if (!resp.ok) throw new Error(`fetch ${f.url} -> ${resp.status}`);
      const buf  = await resp.arrayBuffer();
      const bytes = new Uint8Array(buf);
      let bin = '';
      const chunk = 0x8000;
      for (let i = 0; i < bytes.length; i += chunk) {
        bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
      }
      return { fname: f.url.split('/').pop(), style: f.style, b64: btoa(bin) };
    }));
    _robotoB64Cache = cargadas;
  }
  _robotoB64Cache.forEach(f => {
    doc.addFileToVFS(f.fname, f.b64);
    doc.addFont(f.fname, 'Roboto', f.style);
  });
}

async function generarPDF(oferta, imagenOpcional = null, lang = 'es') {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'letter', compress: true });
  // v3: imagen efímera opcional entre ficha y servicios
  const T = I18N[lang] || I18N.es;

  // Cargar Roboto (Unicode) para soportar ₡, —, →, ·, • sin fallback a helvetica WinAnsi
  let FONT = 'helvetica';
  try {
    await cargarFuentesRoboto(doc);
    FONT = 'Roboto';
  } catch (e) {
    console.warn('Roboto no disponible, fallback a helvetica:', e);
  }

  // ── Colores Infra Design ───────────────────────────────────────────────────
  const NAVY       = [1, 46, 64];
  const VERDE      = [135, 183, 73];
  const GRIS       = [84, 84, 84];
  const BLANCO     = [255, 255, 255];
  const GRIS_CLARO = [242, 242, 242];

  const PW = 215.9; // page width letter mm
  const ML = 15;
  const MR = 15;
  const CW = PW - ML - MR;

  let y = 15;

  // ── Helper: salto de página con mini-header ────────────────────────────────
  const checkPage = (neededH) => {
    if (y + neededH > 258) {
      doc.addPage('letter');
      y = 15;
      doc.setFont(FONT,'bold');
      doc.setFontSize(8);
      doc.setTextColor(...NAVY);
      doc.text(`${T.titulo} — ${oferta.numero_ofs || ''}`, ML, y);
      doc.setDrawColor(...VERDE);
      doc.setLineWidth(0.4);
      doc.line(ML, y + 2, PW - MR, y + 2);
      y += 8;
    }
  };

  // ── Helper: fila de ficha bicolor ─────────────────────────────────────────
  const fichaFila = (label, valor, col1W, rowH = 6) => {
    const col2W = CW - col1W;
    doc.setFillColor(...NAVY);
    doc.rect(ML, y, col1W, rowH, 'F');
    doc.setFont(FONT,'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(...BLANCO);
    doc.text(label, ML + 2, y + rowH - 1.8);

    doc.setFillColor(...GRIS_CLARO);
    doc.rect(ML + col1W, y, col2W, rowH, 'F');
    doc.setFont(FONT,'normal');
    doc.setFontSize(8);
    doc.setTextColor(20, 20, 20);
    doc.text(String(valor || '—'), ML + col1W + 2, y + rowH - 1.8);

    doc.setDrawColor(210, 210, 210);
    doc.setLineWidth(0.15);
    doc.rect(ML, y, CW, rowH, 'S');
    y += rowH;
  };

  // ── Helper: fila de ficha 2 columnas (label1|val1 | label2|val2) ──────────
  const fichaFilaDual = (l1, v1, l2, v2, rowH = 6) => {
    const half = CW / 2;
    const lw = 32; // ancho del label dentro de cada mitad

    // Celda 1 — label
    doc.setFillColor(...NAVY);
    doc.rect(ML, y, lw, rowH, 'F');
    doc.setFont(FONT,'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(...BLANCO);
    doc.text(l1, ML + 2, y + rowH - 1.8);

    // Celda 1 — valor
    doc.setFillColor(...GRIS_CLARO);
    doc.rect(ML + lw, y, half - lw, rowH, 'F');
    doc.setFont(FONT,'normal');
    doc.setFontSize(8);
    doc.setTextColor(20, 20, 20);
    doc.text(String(v1 || '—'), ML + lw + 2, y + rowH - 1.8);

    // Celda 2 — label
    doc.setFillColor(...NAVY);
    doc.rect(ML + half, y, lw, rowH, 'F');
    doc.setFont(FONT,'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(...BLANCO);
    doc.text(l2, ML + half + 2, y + rowH - 1.8);

    // Celda 2 — valor
    doc.setFillColor(...GRIS_CLARO);
    doc.rect(ML + half + lw, y, half - lw, rowH, 'F');
    doc.setFont(FONT,'normal');
    doc.setFontSize(8);
    doc.setTextColor(20, 20, 20);
    doc.text(String(v2 || '—'), ML + half + lw + 2, y + rowH - 1.8);

    doc.setDrawColor(210, 210, 210);
    doc.setLineWidth(0.15);
    doc.rect(ML, y, CW, rowH, 'S');
    y += rowH;
  };

  // ── Helper: section header ─────────────────────────────────────────────────
  const sectionHeader = (texto) => {
    checkPage(10);
    doc.setFillColor(...NAVY);
    doc.rect(ML, y, CW, 6, 'F');
    doc.setFont(FONT,'bold');
    doc.setFontSize(8);
    doc.setTextColor(...BLANCO);
    doc.text(texto, ML + 2, y + 4);
    y += 7;
  };

  // ── Logo ──────────────────────────────────────────────────────────────────
  try {
    const resp = await fetch(LOGO_URL);
    const blob = await resp.blob();
    const dataUrl = await new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = () => res(reader.result);
      reader.onerror = rej;
      reader.readAsDataURL(blob);
    });
    doc.addImage(dataUrl, 'PNG', ML, y, 38, 15, undefined, 'FAST');
  } catch (_) { /* logo no disponible */ }

  // ── Título ────────────────────────────────────────────────────────────────
  doc.setFont(FONT,'bold');
  doc.setFontSize(14);
  doc.setTextColor(...NAVY);
  doc.text(T.titulo, PW / 2, y + 5, { align: 'center' });
  doc.setFontSize(11);
  doc.text(oferta.numero_ofs || '', PW / 2, y + 11, { align: 'center' });
  y += 22;

  doc.setDrawColor(...VERDE);
  doc.setLineWidth(0.6);
  doc.line(ML, y, PW - MR, y);
  y += 5;

  // ── Ficha de datos del proyecto ────────────────────────────────────────────
  const fmtFecha = (f) => {
    if (!f) return '—';
    const d = new Date(f);
    return T.fmtFecha(d, T.meses, T.dias);
  };

  const fmtVigencia = () => {
    const dias = oferta.vigencia_dias;
    const venc = oferta.fecha_vencimiento;
    if (!dias && !venc) return '—';
    const partes = [];
    if (dias) partes.push(T.diasVigencia(dias));
    if (venc) partes.push(T.vence(venc.split('T')[0]));
    return partes.join('  ·  ');
  };

  const COL_LABEL = 32;
  // Fila 1: Cliente formal (nombre legal) + Cédula
  fichaFilaDual(T.cliente, oferta.cliente_nombre || '—', T.cedula, oferta.cliente_codigo || '—');
  // Fila 2: Contacto (persona física de trato) + Correo
  fichaFilaDual(T.contacto, oferta.nombre_contacto || '—', T.correo, oferta.correo_contacto || '—');
  // Fila 3: Proyecto (span completo)
  fichaFila(T.proyecto, oferta.nombre_proyecto || '—', COL_LABEL);
  // Fila 4: OFS + Fecha
  fichaFilaDual(T.ofs, oferta.numero_ofs || '—', T.fecha, fmtFecha(oferta.fecha_oferta));
  // Fila 5: Tipología + Vigencia
  fichaFilaDual(T.tipologia, oferta.tipo_servicio_oferta || '—', T.vigencia, fmtVigencia());
  // Fila 6: Ubicación (span completo)
  fichaFila(T.ubicacion, [oferta.canton, oferta.provincia].filter(Boolean).join(', ') || '—', COL_LABEL);

  y += 4;

  // ── Descripción general del proyecto ──────────────────────────────────────
  if (oferta.descripcion_general && oferta.descripcion_general.trim()) {
    checkPage(14);
    const descGenLines = doc.splitTextToSize(oferta.descripcion_general.trim(), CW - 4);
    const descGenH     = descGenLines.length * 4.5 + 6;
    checkPage(descGenH);

    doc.setFillColor(245, 248, 250);
    doc.rect(ML, y, CW, descGenH, 'F');
    doc.setFillColor(...NAVY);
    doc.rect(ML, y, 2, descGenH, 'F');
    doc.setDrawColor(210, 220, 228);
    doc.setLineWidth(0.2);
    doc.rect(ML, y, CW, descGenH, 'S');

    doc.setFont(FONT,'normal');
    doc.setFontSize(8);
    doc.setTextColor(30, 30, 30);
    descGenLines.forEach((line, i) => {
      doc.text(line, ML + 5, y + 4 + i * 4.5);
    });
    y += descGenH + 5;
  }

  // ── Imagen opcional del proyecto ───────────────────────────────────────────
  if (imagenOpcional && imagenOpcional.dataUrl) {
    try {
      const fmt = imagenOpcional.format || 'JPEG';

      // Calcular dimensiones manteniendo proporción dentro del ancho del contenido
      const imgEl = new Image();
      await new Promise((res) => { imgEl.onload = res; imgEl.src = imagenOpcional.dataUrl; });

      const maxW  = CW;
      const maxH  = 70; // máximo 70mm de alto para no romper el flujo
      const ratio = imgEl.naturalWidth / imgEl.naturalHeight;
      let iw = maxW;
      let ih = iw / ratio;
      if (ih > maxH) { ih = maxH; iw = ih * ratio; }

      checkPage(ih + 8);

      // Centrar horizontalmente
      const ix = ML + (CW - iw) / 2;
      doc.addImage(imagenOpcional.dataUrl, fmt, ix, y, iw, ih, undefined, 'FAST');
      y += ih + 6;
    } catch (_) { /* imagen inválida — continuar sin ella */ }
  }

  // ── Servicios cotizados ────────────────────────────────────────────────────
  const colW3 = CW / 3;
  const selectedSet = new Set(oferta.servicios || []);

  const cols3 = [
    [SERVICIOS_CATALOGO[0], SERVICIOS_CATALOGO[1]],
    [SERVICIOS_CATALOGO[2], SERVICIOS_CATALOGO[3]],
    [SERVICIOS_CATALOGO[4], SERVICIOS_CATALOGO[5], SERVICIOS_CATALOGO[6]],
  ];

  const maxHeights = cols3.map(cats => {
    let h = 0;
    cats.forEach(cat => { h += 5 + cat.items.length * 4.5; });
    return h;
  });
  const gridH = Math.max(...maxHeights);

  // La grilla es un bloque monolitico que no se parte entre paginas. Asegurar
  // que el header (7) + grilla (gridH+4) + margen caben juntos; si no, saltar
  // de pagina ANTES de dibujar el header (evita que la grilla pise el footer).
  checkPage(7 + gridH + 8);

  sectionHeader(T.serviciosCotizados);
  const yGridStart = y;

  doc.setFillColor(250, 250, 250);
  doc.rect(ML, y, CW, gridH + 4, 'F');
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.2);
  doc.rect(ML, y, CW, gridH + 4, 'S');

  cols3.forEach((cats, ci) => {
    let cy = yGridStart + 2;
    const cx = ML + ci * colW3;
    cats.forEach(cat => {
      doc.setFillColor(...VERDE);
      doc.rect(cx + 1, cy, colW3 - 2, 4.5, 'F');
      doc.setFont(FONT,'bold');
      doc.setFontSize(6.5);
      doc.setTextColor(...BLANCO);
      doc.text((cat.cat[lang] || cat.cat.es).toUpperCase(), cx + 3, cy + 3.2);
      cy += 5.5;

      cat.items.forEach(item => {
        // El lookup siempre se hace contra item.es porque oferta.servicios guarda los strings en español
        const itemEs = item.es;
        const itemTxt = item[lang] || item.es;
        const isSelected = selectedSet.has(itemEs) ||
          [...selectedSet].some(s => s.toLowerCase().includes(itemEs.toLowerCase().substring(0, 12)));

        doc.setDrawColor(isSelected ? VERDE[0] : GRIS[0], isSelected ? VERDE[1] : GRIS[1], isSelected ? VERDE[2] : GRIS[2]);
        doc.setLineWidth(0.3);
        doc.rect(cx + 2, cy + 0.3, 2.5, 2.5, 'S');
        if (isSelected) {
          doc.setDrawColor(...VERDE);
          doc.setLineWidth(0.5);
          doc.line(cx + 2.3, cy + 1.5, cx + 3.2, cy + 2.5);
          doc.line(cx + 3.2, cy + 2.5, cx + 4.8, cy + 0.5);
        }

        if (isSelected) {
          doc.setFont(FONT,'bold');
          doc.setTextColor(...NAVY);
        } else {
          doc.setFont(FONT,'normal');
          doc.setTextColor(...GRIS);
        }
        doc.setFontSize(6.2);
        const maxW = colW3 - 8;
        let txt = itemTxt;
        while (doc.getTextWidth(txt) > maxW && txt.length > 10) txt = txt.slice(0, -1);
        if (txt !== itemTxt) txt = txt.slice(0, -1) + '…';
        doc.text(txt, cx + 5.5, cy + 2.2);
        cy += 4.2;
      });
      cy += 1;
    });
  });

  y = yGridStart + gridH + 8;

  // ── Tabla honorarios — descripción inline bajo cada ítem ──────────────────
  sectionHeader(T.honorarios);

  const hCols    = [12, CW - 12 - 38 - 62, 38, 62];
  const hLabels  = [T.item, T.descripcion, T.costoIva, T.terminos];
  const lineas   = oferta.lineas || [];
  // En PDF inglés con Colones usamos "CRC" (ISO 4217) para mayor claridad internacional
  const monedaSym = oferta.moneda === 'Colones'
    ? (lang === 'en' ? 'CRC' : '₡')
    : '$';
  const fmtNum   = (n) => Number(n || 0).toLocaleString('es-CR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // Encabezado tabla
  let xc = ML;
  hCols.forEach((w, i) => {
    doc.setFillColor(...NAVY);
    doc.rect(xc, y, w, 6, 'F');
    doc.setFont(FONT,'bold');
    doc.setFontSize(7);
    doc.setTextColor(...BLANCO);
    doc.text(hLabels[i], xc + 1.5, y + 4);
    xc += w;
  });
  y += 6;

  lineas.forEach((linea, li) => {
    const monto      = parseFloat(linea.monto) || 0;
    const iva        = linea.exonerado ? 0 : monto * 0.13;
    const totalIVA   = monto + iva;
    const hitos      = linea.hitos || [];
    const descLarga  = (linea.descripcion_larga || '').trim();
    const rowH       = 5.5;

    // Calcular altura de descripción corta (puede ocupar varias líneas)
    doc.setFont(FONT,'bold');
    doc.setFontSize(7.5);
    const descCorta      = linea.descripcion_corta || '';
    const wrappedCorta   = doc.splitTextToSize(descCorta, hCols[1] - 3);
    const lineH          = 4.2; // interlineado por línea de texto
    const cortaH         = wrappedCorta.length * lineH + 3; // alto que ocupa la desc corta + padding

    // Calcular altura zona hitos: mínimo cortaH para que quepa la descripción, o tantas filas como hitos
    const hitosH   = Math.max(hitos.length * rowH, cortaH);
    const descLines = descLarga ? doc.splitTextToSize(descLarga, hCols[1] - 4) : [];
    const descH     = descLines.length > 0 ? descLines.length * 4.2 + 4 : 0;
    const totalH    = hitosH + descH;

    checkPage(totalH + 2);

    const bgFill = li % 2 === 0 ? GRIS_CLARO : BLANCO;

    // ── Col 1: N° ítem ──────────────────────────────────────────────────────
    doc.setFillColor(...bgFill);
    doc.rect(ML, y, hCols[0], totalH, 'F');
    doc.setFont(FONT,'bold');
    doc.setFontSize(8);
    doc.setTextColor(...NAVY);
    doc.text(String(linea.numero_linea || li + 1), ML + hCols[0] / 2, y + hitosH / 2 + 1.5, { align: 'center' });

    // ── Col 2: Descripción corta (parte superior) + descripción larga (inferior) ─
    const x2 = ML + hCols[0];
    doc.setFillColor(...bgFill);
    doc.rect(x2, y, hCols[1], totalH, 'F');

    // Descripción corta — todas las líneas
    doc.setFont(FONT,'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(20, 20, 20);
    doc.text(wrappedCorta, x2 + 1.5, y + 3.5, { lineHeightFactor: lineH / (7.5 * 0.352778) });
    if (linea.es_recurrente && linea.unidad) {
      doc.setFont(FONT,'italic');
      doc.setFontSize(6.5);
      doc.setTextColor(...GRIS);
      doc.text(T.porUnidad(linea.unidad), x2 + 1.5, y + cortaH + 1);
    }

    // Descripción larga — cursiva gris, en sub-banda al fondo de la col 2
    if (descLines.length > 0) {
      const descY = y + hitosH;
      // Sub-fondo ligeramente diferenciado
      const subBg = li % 2 === 0 ? [235, 240, 235] : [245, 248, 245];
      doc.setFillColor(...subBg);
      doc.rect(x2, descY, hCols[1], descH, 'F');
      // Acento verde izquierdo
      doc.setFillColor(...VERDE);
      doc.rect(x2, descY, 1.5, descH, 'F');

      doc.setFont(FONT,'italic');
      doc.setFontSize(7);
      doc.setTextColor(60, 60, 60);
      descLines.forEach((line, dli) => {
        doc.text(line, x2 + 3.5, descY + 3 + dli * 4.2);
      });
    }

    // ── Col 3: Costo ────────────────────────────────────────────────────────
    const x3 = x2 + hCols[1];
    doc.setFillColor(...bgFill);
    doc.rect(x3, y, hCols[2], totalH, 'F');
    // Shrink-to-fit: reduce el fontSize si el texto no cabe en la columna
    const fitFontSize = (txt, baseSize, minSize, maxW) => {
      let fs = baseSize;
      doc.setFontSize(fs);
      while (doc.getTextWidth(txt) > maxW && fs > minSize) {
        fs -= 0.5;
        doc.setFontSize(fs);
      }
      return fs;
    };
    const maxMontoW = hCols[2] - 2; // padding 1mm cada lado
    // Monto sin IVA — principal
    doc.setFont(FONT,'bold');
    doc.setTextColor(...NAVY);
    const txtMonto = `${monedaSym} ${fmtNum(monto)}`;
    fitFontSize(txtMonto, 7.5, 5.5, maxMontoW);
    doc.text(txtMonto, x3 + hCols[2] / 2, y + hitosH / 2 - 1.5, { align: 'center' });
    // Etiqueta +IVA
    doc.setFont(FONT,'normal');
    doc.setFontSize(6);
    doc.setTextColor(...GRIS);
    doc.text(linea.exonerado ? T.exonerado : T.iva, x3 + hCols[2] / 2, y + hitosH / 2 + 2, { align: 'center' });
    // Total con IVA — referencia sutil
    if (!linea.exonerado) {
      doc.setFont(FONT,'normal');
      doc.setTextColor(135, 183, 73); // verde sutil
      const txtTotal = `= ${monedaSym} ${fmtNum(totalIVA)}`;
      fitFontSize(txtTotal, 6, 4.5, maxMontoW);
      doc.text(txtTotal, x3 + hCols[2] / 2, y + hitosH / 2 + 5.5, { align: 'center' });
    }

    // ── Col 4: Hitos ────────────────────────────────────────────────────────
    const x4 = x3 + hCols[2];
    doc.setFillColor(...bgFill);
    doc.rect(x4, y, hCols[3], totalH, 'F');

    if (hitos.length > 0) {
      hitos.forEach((h, hi) => {
        const pct       = parseFloat(h.porcentaje) || 0;
        const montoHito = monto * pct / 100;
        const hy        = y + hi * rowH;

        // Layout fijo: [nombre | pct | monto+IVA]
        // Zonas proporcionales al ancho de la columna (hCols[3])
        const zNom = hCols[3] * 0.38; // 38% para el nombre
        const zPct = hCols[3] * 0.15; // 15% para el porcentaje
        // resto (47%) para el monto — alineado a la derecha

        // Nombre — truncado si supera su zona
        doc.setFont(FONT,'normal');
        doc.setFontSize(7);
        doc.setTextColor(30, 30, 30);
        let nomTxt = h.nombre_hito || '';
        while (doc.getTextWidth(nomTxt) > zNom - 2 && nomTxt.length > 3)
          nomTxt = nomTxt.slice(0, -1);
        if (nomTxt !== (h.nombre_hito || '')) nomTxt = nomTxt.slice(0, -1) + '…';
        doc.text(nomTxt, x4 + 1.5, hy + 3.5);

        // Porcentaje — centrado en su zona
        doc.setFont(FONT,'bold');
        doc.setFontSize(6.5);
        doc.setTextColor(...GRIS);
        doc.text(`${pct}%`, x4 + zNom + zPct / 2, hy + 3.5, { align: 'center' });

        // Monto + IVA — alineado al borde derecho, con shrink-to-fit
        doc.setFont(FONT,'bold');
        doc.setTextColor(...NAVY);
        const ivaStr  = linea.exonerado ? '' : T.masIva;
        const txtHito = `${monedaSym} ${fmtNum(montoHito)}${ivaStr}`;
        const maxHitoW = hCols[3] * 0.47 - 1; // ~47% de la columna asignado al monto
        fitFontSize(txtHito, 7, 5, maxHitoW);
        doc.text(txtHito, x4 + hCols[3] - 1, hy + 3.5, { align: 'right' });

        if (hi < hitos.length - 1) {
          doc.setDrawColor(220, 220, 220);
          doc.setLineWidth(0.15);
          doc.line(x4, hy + rowH, x4 + hCols[3], hy + rowH);
        }
      });
    } else {
      doc.setFont(FONT,'normal');
      doc.setFontSize(7);
      doc.setTextColor(...GRIS);
      doc.text('—', x4 + hCols[3] / 2, y + rowH / 2 + 1.5, { align: 'center' });
    }

    // Bordes de fila completa
    doc.setDrawColor(210, 210, 210);
    doc.setLineWidth(0.2);
    xc = ML;
    hCols.forEach(w => { doc.rect(xc, y, w, totalH, 'S'); xc += w; });

    // Línea separadora entre zona hitos y zona descripción (solo col 2)
    if (descH > 0) {
      doc.setDrawColor(200, 215, 200);
      doc.setLineWidth(0.15);
      doc.line(x2, y + hitosH, x2 + hCols[1], y + hitosH);
    }

    y += totalH;
  });

  y += 5;

  // ── Comentarios / Condiciones generales ───────────────────────────────────
  if (oferta.condiciones_generales && oferta.condiciones_generales.trim()) {
    sectionHeader(T.comentarios);

    const condLines = doc.splitTextToSize(oferta.condiciones_generales, CW - 4);
    const condH     = condLines.length * 4.5 + 4;
    checkPage(condH);

    doc.setFillColor(255, 252, 235);
    doc.rect(ML, y, CW, condH, 'F');
    doc.setDrawColor(220, 200, 100);
    doc.setLineWidth(0.2);
    doc.rect(ML, y, CW, condH, 'S');
    doc.setFont(FONT,'normal');
    doc.setFontSize(7.5);
    doc.setTextColor(60, 50, 10);
    condLines.forEach((line, i) => {
      doc.text(line, ML + 2, y + 3.5 + i * 4.5);
    });
    y += condH + 5;
  }

  // ── Firmas ────────────────────────────────────────────────────────────────
  checkPage(30);
  const fw = CW / 2 - 5;

  doc.setDrawColor(...NAVY);
  doc.setLineWidth(0.4);
  doc.line(ML, y + 12, ML + fw, y + 12);
  doc.setFont(FONT,'bold');
  doc.setFontSize(8);
  doc.setTextColor(...NAVY);
  doc.text('Ing. Juan Carlos Núñez Sancho', ML, y + 16);
  doc.setFont(FONT,'normal');
  doc.setFontSize(7.5);
  doc.setTextColor(...GRIS);
  doc.text(T.director, ML, y + 20);

  const xCliente = ML + fw + 10;
  doc.setDrawColor(...NAVY);
  doc.setLineWidth(0.4);
  doc.line(xCliente, y + 12, xCliente + fw, y + 12);
  doc.setFont(FONT,'bold');
  doc.setFontSize(8);
  doc.setTextColor(...NAVY);
  doc.text(oferta.nombre_contacto || oferta.cliente_nombre || T.clienteFirma, xCliente, y + 16);
  doc.setFont(FONT,'normal');
  doc.setFontSize(7.5);
  doc.setTextColor(...GRIS);
  doc.text(T.clienteFirma, xCliente, y + 20);

  y += 28;

  // ── Footer en todas las páginas ────────────────────────────────────────────
  const totalPages = doc.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    const fy = 270;
    doc.setDrawColor(...VERDE);
    doc.setLineWidth(0.5);
    doc.line(ML, fy - 2, PW - MR, fy - 2);
    doc.setFont(FONT,'bold');
    doc.setFontSize(7.5);
    doc.setTextColor(...NAVY);
    doc.text(T.footerEmpresa, ML, fy + 2);
    doc.setFont(FONT,'normal');
    doc.setTextColor(...GRIS);
    doc.text(T.pagina(i, totalPages), PW - MR, fy + 2, { align: 'right' });
    doc.setFontSize(7);
    doc.text('+506 4052-3117  |  info@infra-designcr.com  |  www.infra-designcr.com', PW / 2, fy + 6, { align: 'center' });
  }

  // ── Guardar ────────────────────────────────────────────────────────────────
  const langSuffix = lang === 'en' ? ' (EN)' : '';
  const filename = `OFS ${oferta.numero_ofs || 'oferta'}${langSuffix} — ${(oferta.nombre_proyecto || 'proyecto').replace(/[/\\?%*:|"<>]/g, '-')}.pdf`;
  doc.save(filename);
}

// ── Componente principal ───────────────────────────────────────────────────────
export default function OfertasCliente() {
  const isAdmin = useAdmin();
  const [ofertas,       setOfertas]      = useState([]);
  const [clientes,      setClientes]     = useState([]);
  const [tiposServicio,    setTiposServicio]  = useState([]);
  const [cotizaciones,  setCotizaciones] = useState([]);
  const [loading,       setLoading]      = useState(true);
  const [modal,         setModal]        = useState(false);
  const [editando,      setEditando]     = useState(null);
  const [form,          setForm]         = useState(formVacio);
  const [detalle,       setDetalle]      = useState(null);
  const [imagenPDF,     setImagenPDF]    = useState(null); // { dataUrl, name } — efímero, no se guarda
  const [error,         setError]        = useState('');
  const [ofsError,      setOfsError]     = useState('');
  const [filtro,        setFiltro]       = useState('');
  const [filtroEst,     setFiltroEst]    = useState('');
  const [modalEliminar, setModalEliminar]= useState(null);
  const [cobrosLigados, setCobrosLigados]= useState({ tiene: false, count: 0 });

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const [rO, rC, rT, rCot] = await Promise.all([
        apiFetch(`${API}/ofertas-cliente`),
        apiFetch(`${API}/clientes`),
        apiFetch(`${API}/listas?lista=tipo_servicio_oferta`),
        apiFetch(`${API}/cotizaciones`)
      ]);
      setOfertas(await rO.json());
      setClientes(await rC.json());
      setTiposServicio((await rT.json()).map(d => d.valor));
      setCotizaciones(await rCot.json());
    } catch { /* silencioso */ }
    setLoading(false);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  // ── Cálculos ───────────────────────────────────────────────────────────────
  const calcTotales = (lineas) => {
    let sub = 0, grav = 0, exo = 0;
    (lineas || []).forEach(l => {
      const m = parseFloat(l.monto) || 0;
      sub += m;
      l.exonerado ? (exo += m) : (grav += m);
    });
    return { sub, grav, exo, iva: grav * 0.13, total: sub + grav * 0.13 };
  };

  const calcPresupTotal = (presupuesto) =>
    (presupuesto || []).reduce((s, p) => {
      const c = (parseFloat(p.precio_unitario) || 0) * (parseFloat(p.cantidad) || 1);
      return s + c + c * ((parseFloat(p.utilidad_pct) || 0) / 100);
    }, 0);

  // ── Helpers form ───────────────────────────────────────────────────────────
  const calcFechaVencimiento = (fechaOferta, vigenciaDias) => {
    if (!fechaOferta || !vigenciaDias) return '';
    const d = new Date(fechaOferta);
    d.setDate(d.getDate() + parseInt(vigenciaDias));
    return d.toISOString().split('T')[0];
  };

  const setF = (k, v) => setForm(f => {
    const upd = { ...f, [k]: v };
    if (k === 'fecha_oferta' || k === 'vigencia_dias') {
      upd.fecha_vencimiento = calcFechaVencimiento(
        k === 'fecha_oferta' ? v : f.fecha_oferta,
        k === 'vigencia_dias' ? v : f.vigencia_dias
      );
    }
    return upd;
  });

  // Subcontrato medido en la moneda de la oferta y SIN IVA. El IVA es
  // pass-through (no es utilidad) y la oferta tambien se compara sin IVA, asi
  // la utilidad queda sobre bases homogeneas. Se recalcula en vivo desde la
  // cotizacion para no depender de monto_cotizacion_convertido cacheado
  // (registros viejos quedaron almacenados con IVA).
  const subcontratoSinIva = (linea, cot, moneda) => {
    if (!cot) return 0;
    const sinIva = (parseFloat(cot.monto_total_con_iva) || 0) - (parseFloat(cot.monto_iva) || 0);
    if (cot.moneda === moneda) return sinIva;
    const tc = parseFloat(linea.tipo_cambio) || 0;
    if (!tc) return sinIva;
    return moneda === 'Dólares' ? sinIva / tc : sinIva * tc;
  };

  const setLinea = (i, k, v) => setForm(f => {
    const lineas = [...f.lineas];
    lineas[i] = { ...lineas[i], [k]: v };
    if (k === 'cotizacion_id' || k === 'tipo_cambio') {
      const newLinea = { ...lineas[i], [k]: v };
      const cot = cotizaciones.find(c => c.id === parseInt(newLinea.cotizacion_id));
      // Cachear el convertido SIN IVA solo cuando es calculable (misma moneda,
      // o distinta moneda con tipo de cambio); en cualquier otro caso, null.
      newLinea.monto_cotizacion_convertido =
        (cot && (cot.moneda === f.moneda || newLinea.tipo_cambio))
          ? subcontratoSinIva(newLinea, cot, f.moneda)
          : null;
      lineas[i] = newLinea;
    }
    return { ...f, lineas };
  });

  const addLinea  = () => setForm(f => ({ ...f, lineas: [...f.lineas, lineaVacia(f.lineas.length + 1)] }));
  const delLinea  = (i) => setForm(f => {
    if (f.lineas.length <= 1) return f;
    const lineas = f.lineas.filter((_, idx) => idx !== i).map((l, idx) => ({ ...l, numero_linea: idx + 1 }));
    return { ...f, lineas };
  });

  const setHito  = (li, hi, k, v) => setForm(f => { const ls=[...f.lineas]; const hs=[...ls[li].hitos]; hs[hi]={...hs[hi],[k]:v}; ls[li]={...ls[li],hitos:hs}; return {...f,lineas:ls}; });
  const addHito  = (li) => setForm(f => { const ls=[...f.lineas]; ls[li]={...ls[li],hitos:[...ls[li].hitos,hitoVacio()]}; return {...f,lineas:ls}; });
  const delHito  = (li, hi) => setForm(f => { const ls=[...f.lineas]; ls[li]={...ls[li],hitos:ls[li].hitos.filter((_,idx)=>idx!==hi)}; return {...f,lineas:ls}; });

  const setPresup = (li, pi, k, v) => setForm(f => { const ls=[...f.lineas]; const ps=[...ls[li].presupuesto]; ps[pi]={...ps[pi],[k]:v}; ls[li]={...ls[li],presupuesto:ps}; return {...f,lineas:ls}; });
  const addPresup = (li) => setForm(f => { const ls=[...f.lineas]; ls[li]={...ls[li],presupuesto:[...ls[li].presupuesto,presupVacio(ls[li].presupuesto.length+1)]}; return {...f,lineas:ls}; });
  const delPresup = (li, pi) => setForm(f => { const ls=[...f.lineas]; ls[li]={...ls[li],presupuesto:ls[li].presupuesto.filter((_,idx)=>idx!==pi).map((p,idx)=>({...p,numero_item:idx+1}))}; return {...f,lineas:ls}; });

  const toggleServicio = (srv) => setForm(f => ({
    ...f, servicios: f.servicios.includes(srv) ? f.servicios.filter(s => s !== srv) : [...f.servicios, srv]
  }));

  const fillCliente = (clienteId) => {
    const c = clientes.find(cl => cl.id === parseInt(clienteId));
    setForm(f => ({ ...f, cliente_id: clienteId, nombre_contacto: c?.contacto || '', telefono_contacto: c?.telefono || '', correo_contacto: c?.correo || '' }));
  };

  const validarOfs = async (valor) => {
    if (!valor) { setOfsError(''); return; }
    try {
      const todos = await apiFetch(`${API}/ofertas-cliente`).then(r => r.json());
      const dup   = todos.find(o => o.numero_ofs.toLowerCase() === valor.toLowerCase() && (!editando || o.id !== editando));
      setOfsError(dup ? `El N° OFS "${valor}" ya existe.` : '');
    } catch { setOfsError(''); }
  };

  const validarLineas = () => {
    for (const l of form.lineas) {
      const montoOferta = parseFloat(l.monto) || 0;
      if (l.cotizacion_id) {
        const cot = cotizaciones.find(c => c.id === parseInt(l.cotizacion_id));
        const subSinIva = subcontratoSinIva(l, cot, form.moneda);
        if (cot && montoOferta < subSinIva)
          return `Ítem "${(l.descripcion_corta || l.numero_linea)}": el monto de la oferta sin IVA (${fmt(montoOferta)}) es inferior al subcontrato sin IVA (${fmt(subSinIva)}). No se puede guardar.`;
      }
      if (l.hitos && l.hitos.length > 0) {
        const sumaPct = l.hitos.reduce((s, h) => s + (parseFloat(h.porcentaje) || 0), 0);
        if (Math.abs(sumaPct - 100) > 0.01)
          return `Ítem "${(l.descripcion_corta || l.numero_linea)}": los hitos deben sumar 100% (actual: ${fmtPct(sumaPct)}%).`;
      }
    }
    return null;
  };

  const guardar = async () => {
    setError('');
    if (!form.numero_ofs.trim())      { setError('El N° OFS es requerido.'); return; }
    if (!form.nombre_proyecto.trim()) { setError('El nombre del proyecto es requerido.'); return; }
    if (!form.facturar_con)           { setError('Seleccioná la empresa de facturación.'); return; }
    if (ofsError)                     { setError(ofsError); return; }
    const errLineas = validarLineas();
    if (errLineas) { setError(errLineas); return; }

    const body = {
      ...form,
      cliente_id: form.cliente_id ? parseInt(form.cliente_id) : null,
      lineas: form.lineas
        .filter(l => (l.descripcion_corta || '').trim())
        .map((l, i) => ({
          numero_linea:                i + 1,
          descripcion_corta:           l.descripcion_corta           || null,
          descripcion_larga:           l.descripcion_larga           || null,
          notas:                       l.notas                       || null,
          monto:                       parseFloat(l.monto)           || 0,
          exonerado:                   l.exonerado                   ? 1 : 0,
          cotizacion_id:               l.cotizacion_id               ? parseInt(l.cotizacion_id) : null,
          tipo_cambio:                 l.tipo_cambio                 ? parseFloat(l.tipo_cambio) : null,
          monto_cotizacion_convertido: l.monto_cotizacion_convertido ? parseFloat(l.monto_cotizacion_convertido) : null,
          es_recurrente:               l.es_recurrente               ? 1 : 0,
          unidad:                      l.unidad                      || null,
          hitos:       l.hitos.filter(h => (h.nombre_hito || '').trim()),
          presupuesto: l.presupuesto
            .filter(p => (p.descripcion || '').trim())
            .map(p => ({
              numero_item:     p.numero_item,
              descripcion:     p.descripcion    || '',
              precio_unitario: parseFloat(p.precio_unitario) || 0,
              unidad:          p.unidad         || null,
              cantidad:        parseFloat(p.cantidad) || 1,
              utilidad_pct:    parseFloat(p.utilidad_pct) || 0,
            }))
        }))
    };

    try {
      const url    = editando ? `${API}/ofertas-cliente?id=${editando}` : `${API}/ofertas-cliente`;
      const method = editando ? 'PUT' : 'POST';
      const resp   = await apiFetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const data   = await resp.json();
      if (!resp.ok) { setError(data.error || 'Error al guardar'); return; }

      // Si editando y el estado cambió a Aprobada → sincronizar proyecto
      const idGuardado = editando || data.id;
      if (form.estado === 'Aprobada' && estadoOriginal !== 'Aprobada') {
        await apiFetch(`${API}/ofertas-cliente?id=${idGuardado}&action=aprobar`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({})
        });
      }

      setModal(false);
      cargar();
    } catch (e) { setError('Error de conexión: ' + e.message); }
  };

  const nuevo = () => { setForm(formVacio); setEditando(null); setEstadoOriginal(''); setError(''); setOfsError(''); setCobrosLigados({ tiene: false, count: 0 }); setModal(true); };

  const editar = async (oferta) => {
    try {
      const data = await apiFetch(`${API}/ofertas-cliente?id=${oferta.id}`).then(r => r.json());
      setForm({
        numero_ofs:            data.numero_ofs            || '',
        nombre_proyecto:       data.nombre_proyecto       || '',
        descripcion_general:   data.descripcion_general   || '',
        cliente_id:            data.cliente_id            || '',
        nombre_contacto:       data.nombre_contacto       || '',
        telefono_contacto:     data.telefono_contacto     || '',
        correo_contacto:       data.correo_contacto       || '',
        tipo_servicio_oferta:  data.tipo_servicio_oferta    || '',
        moneda:                data.moneda                || 'Dólares',
        provincia:             data.provincia             || 'San José',
        canton:                data.canton                || '',
        distrito:              data.distrito              || '',
        direccion:             data.direccion             || '',
        facturar_con:          data.facturar_con          || 'JyA Conusa',
        estado:                data.estado                || 'Borrador',
        condiciones_generales: data.condiciones_generales || '',
        fecha_oferta:          data.fecha_oferta ? data.fecha_oferta.split('T')[0] : '',
        vigencia_dias:         data.vigencia_dias || 30,
        fecha_vencimiento:     data.fecha_vencimiento ? data.fecha_vencimiento.split('T')[0] : '',
        servicios:             data.servicios             || [],
        lineas: (data.lineas || []).map(l => ({
          numero_linea:                l.numero_linea,
          descripcion_corta:           l.descripcion_corta  || '',
          descripcion_larga:           l.descripcion_larga  || '',
          notas:                       l.notas              || '',
          monto:                       l.monto              || '',
          exonerado:                   !!l.exonerado,
          cotizacion_id:               l.cotizacion_id      || '',
          tipo_cambio:                 l.tipo_cambio        || '',
          monto_cotizacion_convertido: l.monto_cotizacion_convertido || null,
          es_recurrente:               l.es_recurrente === true || l.es_recurrente === 1,
          unidad:                      l.unidad || '',
          hitos: (l.hitos || []).map(h => ({ nombre_hito: h.nombre_hito, porcentaje: h.porcentaje })),
          presupuesto: (l.presupuesto || []).map(p => ({
            numero_item:     p.numero_item,
            descripcion:     p.descripcion    || '',
            precio_unitario: p.precio_unitario || '',
            unidad:          p.unidad         || '',
            cantidad:        p.cantidad       || 1,
            utilidad_pct:    p.utilidad_pct   || 30,
          })),
          _showPresup:      false,
          _showSubcontrato: !!l.cotizacion_id,
          _showHitos:       (l.hitos || []).length > 0
        }))
      });
      setCobrosLigados({ tiene: !!data.tiene_cobros_ligados, count: data.cobros_count || 0 });
      setEditando(oferta.id); setEstadoOriginal(data.estado || 'Borrador'); setError(''); setOfsError(''); setModal(true);
    } catch (e) { alert('Error al cargar: ' + e.message); }
  };

  const [modalAprobar,     setModalAprobar]  = useState(null);
  const [aprobando,        setAprobando]     = useState(false);
  const [genProy,          setGenProy]       = useState(null); // generar proyeccion tras aprobar (opcion C)
  const [estadoOriginal,   setEstadoOriginal]= useState('');
  const [proyectoPrevio,      setProyectoPrevio]      = useState(null);
  const [cargandoProyPrevio,  setCargandoProyPrevio]  = useState(false);

  // Cuando se abre el modal de aprobación, buscar si ya existe proyecto para pre-cargar
  useEffect(() => {
    if (!modalAprobar) { setProyectoPrevio(null); return; }
    let cancelado = false;
    setCargandoProyPrevio(true);
    setProyectoPrevio(null);
    apiFetch(`${API}/proyectos`)
      .then(r => r.json())
      .then(data => {
        if (cancelado) return;
        const encontrado = (data || []).find(p => p.id_proyecto === modalAprobar.numero_ofs);
        setProyectoPrevio(encontrado || null);
      })
      .catch(() => { if (!cancelado) setProyectoPrevio(null); })
      .finally(() => { if (!cancelado) setCargandoProyPrevio(false); });
    return () => { cancelado = true; };
  }, [modalAprobar?.id]);

  const confirmarAprobar = async (extras) => {
    if (!modalAprobar) return;
    const ofertaId = modalAprobar.id;
    setAprobando(true);
    try {
      const resp = await apiFetch(`${API}/ofertas-cliente?id=${ofertaId}&action=aprobar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(extras || {})
      });
      const data = await resp.json();
      if (!resp.ok) { alert('Error al aprobar: ' + (data.error || 'Error desconocido')); return; }

      // Opcion C: encadenar la generacion de proyeccion (obligatoria), salvo que el
      // proyecto ya tenga proyecciones (re-aprobacion o generadas a mano) -> no duplicar.
      if (data.id_proyecto) {
        let yaTiene = false;
        try {
          const pf = await apiFetch(`${API}/proyeccion-facturacion?proyecto_id=${encodeURIComponent(data.id_proyecto)}`).then(r => r.json());
          yaTiene = Array.isArray(pf) && pf.length > 0;
        } catch (_) { /* si falla la verificacion, igual se ofrece generar */ }
        if (!yaTiene) {
          setGenProy({ ofertaId, proyectoId: data.id_proyecto, moneda: data.moneda, facturarCon: data.facturar_con });
        }
      }
    } catch (e) { alert('Error de conexión: ' + e.message); }
    finally {
      setAprobando(false);
      setModalAprobar(null);
      await cargar();
    }
  };

  const confirmarEliminar = async () => {
    if (!modalEliminar) return;
    try {
      await apiFetch(`${API}/ofertas-cliente?id=${modalEliminar.id}&hard=true`, { method: 'DELETE' });
      setModalEliminar(null); setDetalle(null); cargar();
    } catch (e) { alert('Error al eliminar: ' + e.message); }
  };

  const ofertasFiltradas = ofertas.filter(o => {
    const txt = filtro.toLowerCase();
    return (!txt || o.numero_ofs?.toLowerCase().includes(txt) || o.nombre_proyecto?.toLowerCase().includes(txt) || o.cliente_nombre?.toLowerCase().includes(txt))
      && (!filtroEst || estadoEfectivo(o) === filtroEst);
  }).sort((a, b) => (b.numero_ofs || '').localeCompare(a.numero_ofs || '', undefined, { numeric: true }));

  const stats = {
    total:      ofertas.length,
    enviadas:   ofertas.filter(o => estadoEfectivo(o) === 'Enviada').length,
    aprobadas:  ofertas.filter(o => estadoEfectivo(o) === 'Aprobada').length,
    rechazadas: ofertas.filter(o => estadoEfectivo(o) === 'Rechazada').length,
    vencidas:   ofertas.filter(o => estadoEfectivo(o) === 'Vencida').length,
  };

  const t = calcTotales(form.lineas);

  // ── Render línea de honorario ──────────────────────────────────────────────
  const renderLinea = (l, i) => {
    const montoNum    = parseFloat(l.monto) || 0;
    const totalLinea  = l.exonerado ? montoNum : montoNum * 1.13;
    const sumPct      = l.hitos.reduce((s, h) => s + (parseFloat(h.porcentaje) || 0), 0);
    const pctOk       = l.hitos.length === 0 || Math.abs(sumPct - 100) < 0.01;
    const presupTotal = calcPresupTotal(l.presupuesto);
    const cot         = cotizaciones.find(c => c.id === parseInt(l.cotizacion_id));
    const necesitaTC  = cot && cot.moneda !== form.moneda;
    // Ambos lados SIN IVA: oferta (montoNum, ya sin IVA) vs subcontrato.
    const subSinIvaCot = cot ? (parseFloat(cot.monto_total_con_iva) || 0) - (parseFloat(cot.monto_iva) || 0) : 0;
    const montoConv    = subcontratoSinIva(l, cot, form.moneda);
    const utilOk   = !l.cotizacion_id || montoNum >= montoConv;
    const utilidad = montoNum - montoConv;
    const utilPct  = montoNum > 0 ? (utilidad / montoNum) * 100 : 0;

    const fInput   = { ...inputStyle, fontSize:'12px' };
    const fSelect  = { ...inputStyle, fontSize:'12px', background:'#fff' };
    const fTextarea= { ...inputStyle, fontSize:'12px', minHeight:'52px', resize:'vertical' };
    const lbl      = { fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px' };

    return (
      <div key={i} style={{ border:'1px solid #e8e8e8', borderRadius:'10px', marginBottom:'10px', overflow:'hidden' }}>

        {/* Bloque contable: congelado si la oferta ya tiene cobros ligados */}
        <fieldset disabled={cobrosLigados.tiene} style={{ border:0, padding:0, margin:0, minWidth:0, opacity: cobrosLigados.tiene ? 0.6 : 1 }}>

        {/* Fila principal */}
        <div style={{ display:'grid', gridTemplateColumns:'24px 1fr 130px 1fr 80px 100px 24px', gap:'8px', alignItems:'end', padding:'12px 14px 10px', background:'#fff' }}>
          <div style={{ fontSize:'11px', color:'#aaa', paddingBottom:'6px', fontWeight:'600' }}>{i+1}</div>
          <div>
            <div style={lbl}>Descripción corta</div>
            <input style={fInput} value={l.descripcion_corta}
              onChange={e => setLinea(i,'descripcion_corta',e.target.value)}
              placeholder={`Fase ${i+1}. Descripción...`} />
          </div>
          <div>
            <div style={lbl}>{l.es_recurrente ? 'Tarifa unitaria' : 'Monto (sin IVA)'}</div>
            <input type="number" style={{ ...fInput, textAlign:'right' }}
              value={l.monto} onChange={e => setLinea(i,'monto',e.target.value)}
              placeholder="0.00" />
          </div>
          <div>
            <div style={lbl}>Tarifa unitaria</div>
            <div style={{ display:'flex', alignItems:'center', gap:'8px', marginTop:'6px' }}>
              <label style={{ position:'relative', display:'inline-block', width:'34px', height:'19px' }}>
                <input type="checkbox" checked={l.es_recurrente}
                  onChange={e => setLinea(i,'es_recurrente',e.target.checked)}
                  style={{ opacity:0, width:0, height:0 }} />
                <span style={{ position:'absolute', cursor:'pointer', inset:0, background:l.es_recurrente?'#87B749':'#ccc', borderRadius:'19px', transition:'.2s' }}>
                  <span style={{ position:'absolute', height:'13px', width:'13px', left:l.es_recurrente?'18px':'3px', bottom:'3px', background:'#fff', borderRadius:'50%', transition:'.2s' }} />
                </span>
              </label>
              <span style={{ fontSize:'11px', color:l.es_recurrente?'#3B6D11':'#aaa' }}>{l.es_recurrente?'Recurrente':'Fijo'}</span>
            </div>
            {l.es_recurrente && (
              <input style={{ ...fInput, fontSize:'11px', padding:'4px 8px', marginTop:'4px' }}
                value={l.unidad} onChange={e => setLinea(i,'unidad',e.target.value)}
                placeholder="unidad (visita, hora...)" />
            )}
          </div>
          <div style={{ textAlign:'center' }}>
            <div style={{ ...lbl, textAlign:'center' }}>Exonerado</div>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', marginTop:'6px' }}>
              <label style={{ position:'relative', display:'inline-block', width:'34px', height:'19px' }}>
                <input type="checkbox" checked={l.exonerado}
                  onChange={e => setLinea(i,'exonerado',e.target.checked)}
                  style={{ opacity:0, width:0, height:0 }} />
                <span style={{ position:'absolute', cursor:'pointer', inset:0, background:l.exonerado?'#87B749':'#ccc', borderRadius:'19px', transition:'.2s' }}>
                  <span style={{ position:'absolute', height:'13px', width:'13px', left:l.exonerado?'18px':'3px', bottom:'3px', background:'#fff', borderRadius:'50%', transition:'.2s' }} />
                </span>
              </label>
              <span style={{ fontSize:'10px', color:l.exonerado?'#3B6D11':'#aaa' }}>{l.exonerado?'Exo':'IVA 13%'}</span>
            </div>
          </div>
          <div style={{ textAlign:'right', paddingBottom:'4px' }}>
            <div style={lbl}>Total línea</div>
            <div style={{ fontSize:'13px', fontWeight:'600', color:l.exonerado?'#3B6D11':'#012E40', marginTop:'8px' }}>{fmt(totalLinea)}</div>
          </div>
          <button onClick={() => delLinea(i)} style={{ background:'none', border:'none', color:'#ccc', fontSize:'18px', cursor:'pointer', paddingBottom:'4px' }}>×</button>
        </div>

        {/* Descripciones para PDF */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', padding:'0 14px 12px', background:'#fff' }}>
          <div>
            <div style={lbl}>Descripción del servicio (para PDF)</div>
            <textarea style={fTextarea} value={l.descripcion_larga}
              onChange={e => setLinea(i,'descripcion_larga',e.target.value)}
              placeholder="Descripción detallada para el cliente..." />
          </div>
          <div>
            <div style={lbl}>Notas / comentarios internos</div>
            <textarea style={fTextarea} value={l.notas}
              onChange={e => setLinea(i,'notas',e.target.value)}
              placeholder="Observaciones internas, supuestos..." />
          </div>
        </div>

        {/* Hitos colapsable */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'7px 14px', background:'#f7f7f5', borderTop:'1px solid #f0f0f0', cursor:'pointer', fontSize:'12px', color:'#555', userSelect:'none' }}
          onClick={() => setLinea(i,'_showHitos',!l._showHitos)}>
          <span>
            {l._showHitos ? '▼' : '▶'} Hitos de cobro
            {l.hitos.length > 0 && (
              <span style={{ marginLeft:'8px', fontSize:'11px', color:pctOk?'#3B6D11':'#A32D2D', fontWeight:'600' }}>
                {pctOk ? `✓ ${l.hitos.length} hito(s) — 100%` : `⚠ ${fmtPct(sumPct)}% — debe sumar 100%`}
              </span>
            )}
          </span>
          <span style={{ fontSize:'11px', color:'#aaa' }}>opcional</span>
        </div>
        {l._showHitos && (
          <div style={{ padding:'10px 14px', background:'#fff', borderTop:'1px dashed #e0e0e0' }}>
            {l.hitos.map((h, hi) => (
              <div key={hi} style={{ display:'grid', gridTemplateColumns:'1fr 90px 16px 24px', gap:'6px', marginBottom:'6px', alignItems:'center' }}>
                <input style={{ ...fInput, padding:'5px 8px' }} value={h.nombre_hito}
                  onChange={e => setHito(i,hi,'nombre_hito',e.target.value)} placeholder="Nombre del hito" />
                <input type="number" style={{ ...fInput, padding:'5px 8px', textAlign:'right' }}
                  value={h.porcentaje} onChange={e => setHito(i,hi,'porcentaje',e.target.value)} placeholder="%" />
                <span style={{ fontSize:'11px', color:'#888' }}>%</span>
                <button onClick={() => delHito(i,hi)} style={{ background:'none', border:'none', color:'#ccc', fontSize:'14px', cursor:'pointer' }}>×</button>
              </div>
            ))}
            <button onClick={() => addHito(i)} style={{ background:'none', border:'none', fontSize:'11px', color:'#87B749', cursor:'pointer', padding:0, marginTop:'2px', fontWeight:'600' }}>+ Agregar hito</button>
          </div>
        )}
        </fieldset>
        {/* Subcontrato y presupuesto interno: NO contables, editables aun con cobros */}

        {/* Subcontrato colapsable */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'7px 14px', background:'#f0f7e8', borderTop:'1px solid #d4edbe', cursor:'pointer', fontSize:'12px', color:'#3B6D11', userSelect:'none' }}
          onClick={() => setLinea(i,'_showSubcontrato',!l._showSubcontrato)}>
          <span>
            {l._showSubcontrato ? '▼' : '▶'} Subcontrato / Cotización asociada
            {l.cotizacion_id && (
              <span style={{ marginLeft:'8px', fontSize:'11px', color:utilOk?'#3B6D11':'#A32D2D', fontWeight:'600' }}>
                {utilOk ? `✓ Utilidad: ${fmt(utilidad)} (${fmtPct(utilPct)}%)` : '⚠ Oferta inferior al subcontrato'}
              </span>
            )}
          </span>
          <span style={{ fontSize:'11px', color:'#aaa' }}>opcional</span>
        </div>
        {l._showSubcontrato && (
          <div style={{ padding:'10px 14px', background:'#f0f7e8', borderTop:'1px dashed #c8e6a0' }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px 16px', marginBottom:'10px' }}>
              <div>
                <div style={lbl}>Cotización del proveedor</div>
                <select style={fSelect} value={l.cotizacion_id}
                  onChange={e => setLinea(i,'cotizacion_id',e.target.value)}>
                  <option value="">Sin subcontrato</option>
                  {cotizaciones.map(c => (
                    <option key={c.id} value={c.id}>
                      {c.numero_oferta} — {c.proveedor_nombre} — {c.moneda} {fmt(c.monto_total_con_iva)}
                    </option>
                  ))}
                </select>
              </div>
              {necesitaTC && (
                <div>
                  <div style={lbl}>Tipo de cambio (1 USD = ₡)</div>
                  <input type="number" style={fInput} value={l.tipo_cambio}
                    onChange={e => setLinea(i,'tipo_cambio',e.target.value)} placeholder="Ej: 520" />
                </div>
              )}
            </div>
            {cot && (
              <div style={{ background:utilOk?'#fff':'#fff0f0', borderRadius:'8px', padding:'10px 14px', fontSize:'12px', border:`1px solid ${utilOk?'#c8e6a0':'#ffcccc'}` }}>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'8px' }}>
                  <div><span style={{ color:'#888' }}>Subcontrato sin IVA ({cot.moneda})</span><br /><strong>{fmt(subSinIvaCot)}</strong></div>
                  {necesitaTC && <div><span style={{ color:'#888' }}>Convertido sin IVA ({form.moneda})</span><br /><strong>{fmt(montoConv)}</strong></div>}
                  <div><span style={{ color:'#888' }}>Monto oferta sin IVA</span><br /><strong>{fmt(montoNum)}</strong></div>
                  <div><span style={{ color:'#888' }}>Utilidad</span><br />
                    <strong style={{ color:utilOk?'#3B6D11':'#A32D2D' }}>
                      {utilOk ? `${fmt(utilidad)} (${fmtPct(utilPct)}%)` : `⚠ Diferencia: ${fmt(montoConv - montoNum)}`}
                    </strong>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Presupuesto colapsable */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'7px 14px', background:'#f7f7f5', borderTop:'1px solid #f0f0f0', cursor:'pointer', fontSize:'12px', color:'#555', userSelect:'none' }}
          onClick={() => setLinea(i,'_showPresup',!l._showPresup)}>
          <span>
            {l._showPresup ? '▼' : '▶'} Presupuesto interno
            {l.presupuesto.length > 0 && <span style={{ color:'#888', marginLeft:'8px' }}>Ref: {fmt(presupTotal)}</span>}
          </span>
          <span style={{ fontSize:'11px', color:'#aaa' }}>opcional</span>
        </div>
        {l._showPresup && (
          <div style={{ padding:'10px 14px', background:'#f7f7f5', borderTop:'1px dashed #e0e0e0' }}>
            <div style={{ fontSize:'11px', color:'#888', marginBottom:'8px' }}>Solo referencia interna — el monto de la oferta se ingresa manualmente.</div>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'11px' }}>
              <thead>
                <tr>{['#','Descripción','Precio Unit.','Unidad','Cantidad','Utilidad %','Total ref.',''].map(h => (
                  <th key={h} style={{ background:'#012E40', color:'#fff', padding:'5px 7px', textAlign:h==='Total ref.'||h==='Precio Unit.'?'right':'left', fontWeight:500 }}>{h}</th>
                ))}</tr>
              </thead>
              <tbody>
                {l.presupuesto.map((p, pi) => {
                  const pu  = parseFloat(p.precio_unitario) || 0;
                  const qty = parseFloat(p.cantidad) || 1;
                  const ut  = parseFloat(p.utilidad_pct) || 0;
                  const c   = pu * qty;
                  const tot = c + c * ut / 100;
                  return (
                    <tr key={pi} style={{ background:pi%2===0?'#fafafa':'#fff' }}>
                      <td style={{ padding:'4px 7px', color:'#aaa', fontSize:'10px' }}>{pi+1}</td>
                      <td style={{ padding:'4px 4px' }}><input style={{ ...inputStyle, fontSize:'11px', padding:'3px 6px' }} value={p.descripcion} onChange={e => setPresup(i,pi,'descripcion',e.target.value)} placeholder="Descripción" /></td>
                      <td style={{ padding:'4px 4px' }}><input type="number" style={{ ...inputStyle, fontSize:'11px', padding:'3px 6px', textAlign:'right', width:'90px' }} value={p.precio_unitario} onChange={e => setPresup(i,pi,'precio_unitario',e.target.value)} /></td>
                      <td style={{ padding:'4px 4px' }}><input style={{ ...inputStyle, fontSize:'11px', padding:'3px 6px', width:'65px' }} value={p.unidad} onChange={e => setPresup(i,pi,'unidad',e.target.value)} placeholder="unidad" /></td>
                      <td style={{ padding:'4px 4px' }}><input type="number" style={{ ...inputStyle, fontSize:'11px', padding:'3px 6px', textAlign:'right', width:'70px' }} value={p.cantidad} onChange={e => setPresup(i,pi,'cantidad',e.target.value)} /></td>
                      <td style={{ padding:'4px 4px' }}><input type="number" style={{ ...inputStyle, fontSize:'11px', padding:'3px 6px', textAlign:'right', width:'65px' }} value={p.utilidad_pct} onChange={e => setPresup(i,pi,'utilidad_pct',e.target.value)} /></td>
                      <td style={{ padding:'4px 7px', textAlign:'right', fontWeight:500, color:'#012E40' }}>{fmt(tot)}</td>
                      <td><button onClick={() => delPresup(i,pi)} style={{ background:'none', border:'none', color:'#ccc', fontSize:'14px', cursor:'pointer' }}>×</button></td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={6} style={{ padding:'5px 7px', textAlign:'right', color:'#888', fontSize:'11px' }}>Total referencia</td>
                  <td style={{ padding:'5px 7px', textAlign:'right', fontWeight:600, color:'#012E40' }}>{fmt(presupTotal)}</td>
                  <td />
                </tr>
              </tfoot>
            </table>
            <button onClick={() => addPresup(i)} style={{ marginTop:'6px', border:'1px dashed #ccc', background:'none', borderRadius:'8px', padding:'4px 12px', fontSize:'11px', cursor:'pointer', color:'#888' }}>+ Agregar sub-ítem</button>
          </div>
        )}
      </div>
    );
  };

  // ── RENDER PRINCIPAL ───────────────────────────────────────────────────────
  return (
    <div style={{ padding:'24px', fontFamily:'Segoe UI, sans-serif', maxWidth:'1200px' }}>

      {/* ── Header ── */}
      <div style={{ background:'#012E40', borderRadius:'12px', padding:'14px 20px', marginBottom:'20px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <span style={{ color:'#fff', fontSize:'17px', fontWeight:'700' }}>Ofertas a Clientes</span>
        <button onClick={nuevo} style={{ padding:'8px 16px', background:'#87B749', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>
          + Nueva oferta
        </button>
      </div>

      {/* ── Stats ── */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'12px', marginBottom:'20px' }}>
        {[
          { label:'Total', valor:stats.total,      color:'#012E40' },
          { label:'Enviadas',    valor:stats.enviadas,   color:'#854F0B' },
          { label:'Aprobadas',   valor:stats.aprobadas,  color:'#3B6D11' },
          { label:'Rechazadas',  valor:stats.rechazadas, color:'#A32D2D' },
        ].map(s => (
          <div key={s.label} style={{ background:'#fff', border:'1px solid #e8e8e8', borderRadius:'10px', padding:'14px 18px' }}>
            <div style={{ fontSize:'11px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px' }}>{s.label}</div>
            <div style={{ fontSize:'26px', fontWeight:'700', color:s.color, marginTop:'4px' }}>{s.valor}</div>
          </div>
        ))}
      </div>

      {/* ── Buscador + filtro ── */}
      <div style={{ display:'flex', gap:'10px', marginBottom:'16px' }}>
        <div style={{ position:'relative', flex:1 }}>
          <svg style={{ position:'absolute', left:'12px', top:'50%', transform:'translateY(-50%)', pointerEvents:'none' }} width="16" height="16" viewBox="0 0 20 20" fill="none">
            <circle cx="9" cy="9" r="6" stroke="#aaa" strokeWidth="1.5"/>
            <path d="M15 15l-3-3" stroke="#aaa" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          <input value={filtro} onChange={e => setFiltro(e.target.value)}
            placeholder="Buscar por N° OFS, nombre de proyecto, cliente..."
            style={{ ...inputStyle, paddingLeft:'38px', borderRadius:'10px' }}/>
        </div>
        <select value={filtroEst} onChange={e => setFiltroEst(e.target.value)}
          style={{ padding:'8px 12px', border:'1px solid #e0e0e0', borderRadius:'10px', fontSize:'13px', background:'#fff', color:'#555' }}>
          <option value="">Todos los estados</option>
          {ESTADOS_FILTRO.map(e => <option key={e}>{e}</option>)}
        </select>
      </div>

      {/* ── Tabla ── */}
      <div style={{ background:'#fff', border:'1px solid #e8e8e8', borderRadius:'12px', overflow:'hidden', marginBottom:'16px' }}>
        {loading ? (
          <div style={{ padding:'40px', textAlign:'center', color:'#888' }}>Cargando...</div>
        ) : ofertasFiltradas.length === 0 ? (
          <div style={{ padding:'40px', textAlign:'center', color:'#bbb' }}>No se encontraron ofertas.</div>
        ) : (
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'13px', minWidth:'780px' }}>
            <thead>
              <tr style={{ background:'#f8f9fa' }}>
                {['N° OFS','Proyecto','Cliente','Servicios cotizados','Moneda','Total','Estado','Acciones'].map(h => (
                  <th key={h} style={{ padding:'11px 14px', textAlign:'left', color:'#888', fontWeight:'600', fontSize:'11px', textTransform:'uppercase', letterSpacing:'0.5px', borderBottom:'1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ofertasFiltradas.map((o, idx) => (
                <tr key={o.id} style={{ borderBottom:'1px solid #f3f3f3', cursor:'pointer' }}
                  onClick={() => apiFetch(`${API}/ofertas-cliente?id=${o.id}`).then(r=>r.json()).then(setDetalle)}
                  onMouseEnter={e => e.currentTarget.style.background='#fafafa'}
                  onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                  <td style={{ padding:'11px 14px', fontWeight:'700', color:'#012E40', whiteSpace:'nowrap', minWidth:'110px' }}>{o.numero_ofs}</td>
                  <td style={{ padding:'11px 14px', fontWeight:'600', color:'#1a1a1a', maxWidth:'180px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{o.nombre_proyecto}</td>
                  <td style={{ padding:'11px 14px', color:'#555' }}>{o.cliente_nombre || '—'}</td>
                  <td style={{ padding:'11px 14px' }}>
                    {(() => {
                      const cats = categoriasDeServicios(o.servicios);
                      if (cats.length > 0) {
                        return (
                          <div style={{ display:'flex', flexWrap:'wrap', gap:'4px' }}>
                            {cats.map(c => (
                              <span key={c} style={{ background:'#eaf3de', color:'#3B6D11', padding:'2px 8px', borderRadius:99, fontSize:'11px', fontWeight:'500', whiteSpace:'nowrap' }}>{c}</span>
                            ))}
                          </div>
                        );
                      }
                      return <span style={{ color:'#888', fontSize:'12px' }}>{o.tipo_servicio_oferta || '—'}</span>;
                    })()}
                  </td>
                  <td style={{ padding:'11px 14px', color:'#555' }}>{o.moneda}</td>
                  <td style={{ padding:'11px 14px', fontWeight:'600', color:'#012E40' }}>{fmt(o.total)}</td>
                  <td style={{ padding:'11px 14px' }}>{badgeEstado(estadoEfectivo(o))}</td>
                  <td style={{ padding:'11px 14px' }}>
                    <div style={{ display:'flex', gap:'6px' }}>
                      <button onClick={e => { e.stopPropagation(); editar(o); }}
                        style={{ padding:'4px 12px', background:'none', border:'1px solid #ddd', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#555' }}>
                        Editar
                      </button>

                      {isAdmin && (
                        <button onClick={e => { e.stopPropagation(); setModalEliminar(o); }}
                          style={{ padding:'4px 12px', background:'none', border:'1px solid #fcc', borderRadius:'6px', fontSize:'12px', cursor:'pointer', color:'#A32D2D' }}>
                          Eliminar
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* ── Panel Ver ── */}
      {detalle && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'20px' }}>
          <div style={{ background:'#fff', borderRadius:'16px', width:'100%', maxWidth:'760px', maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>

            <div style={{ overflowY:'auto', padding:'28px' }}>

              {/* Título y botones */}
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'16px' }}>
                <div>
                  <div style={{ fontSize:'20px', fontWeight:'700', color:'#012E40', marginBottom:'6px' }}>{detalle.nombre_proyecto}</div>
                  <div style={{ display:'flex', gap:'6px', alignItems:'center' }}>
                    <span style={{ fontSize:'13px', color:'#888', fontWeight:'500' }}>{detalle.numero_ofs}</span>
                    {badgeEstado(estadoEfectivo(detalle))}
                  </div>
                </div>
                <div style={{ display:'flex', gap:'8px', alignItems:'center' }}>
                  {(detalle.estado === 'Enviada' || detalle.estado === 'Borrador') && !esVencida(detalle) && (
                    <button onClick={() => { setDetalle(null); setModalAprobar(detalle); }}
                      style={{ padding:'7px 16px', background:'#eaf3de', color:'#3B6D11', border:'1px solid #87B749', borderRadius:'8px', fontSize:'13px', cursor:'pointer', fontWeight:'600' }}>
                      ✓ Aprobar
                    </button>
                  )}
                  <button
                    onClick={() => generarPDF(detalle, imagenPDF, 'es')}
                    title="Descargar PDF de oferta en español"
                    style={{ padding:'7px 14px', background:'#87B749', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', cursor:'pointer', fontWeight:'600', display:'flex', alignItems:'center', gap:'6px' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ flexShrink:0 }}>
                      <path d="M12 3v13M7 11l5 5 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M5 20h14" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    PDF ES
                  </button>
                  <button
                    onClick={() => generarPDF(detalle, imagenPDF, 'en')}
                    title="Download proposal PDF in English"
                    style={{ padding:'7px 14px', background:'#fff', color:'#3B6D11', border:'1px solid #87B749', borderRadius:'8px', fontSize:'13px', cursor:'pointer', fontWeight:'600', display:'flex', alignItems:'center', gap:'6px' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ flexShrink:0 }}>
                      <path d="M12 3v13M7 11l5 5 5-5" stroke="#3B6D11" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M5 20h14" stroke="#3B6D11" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    PDF EN
                  </button>
                  <button onClick={() => { setDetalle(null); editar(detalle); }}
                    style={{ padding:'7px 16px', background:'#012E40', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', cursor:'pointer', fontWeight:'500' }}>
                    Editar
                  </button>
                  {isAdmin && (
                    <button onClick={() => { setDetalle(null); setModalEliminar(detalle); }}
                      style={{ padding:'7px 16px', background:'none', border:'1px solid #fcc', borderRadius:'8px', fontSize:'13px', cursor:'pointer', color:'#A32D2D' }}>
                      Eliminar
                    </button>
                  )}
                  <button onClick={() => { setDetalle(null); setImagenPDF(null); }}
                    style={{ background:'none', border:'none', fontSize:'22px', cursor:'pointer', color:'#aaa', lineHeight:1 }}>×</button>
                </div>
              </div>

              {/* Imagen opcional para PDF */}
              <div style={{ margin:'10px 0 4px', padding:'10px 14px', background:'#f7f9f5', border:'1px dashed #c8ddb0', borderRadius:'10px', display:'flex', alignItems:'center', gap:'12px', flexWrap:'wrap' }}>
                <div style={{ display:'flex', alignItems:'center', gap:'8px', flex:1, minWidth:'220px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ flexShrink:0, color:'#87B749' }}>
                    <rect x="3" y="3" width="18" height="18" rx="2" stroke="#87B749" strokeWidth="1.6"/>
                    <circle cx="8.5" cy="8.5" r="1.5" stroke="#87B749" strokeWidth="1.4"/>
                    <path d="M3 15l5-5 4 4 3-3 6 6" stroke="#87B749" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>
                    <div style={{ fontSize:'11px', fontWeight:'600', color:'#3B6D11' }}>Imagen para el PDF</div>
                    <div style={{ fontSize:'10px', color:'#888', marginTop:'1px' }}>
                      {imagenPDF ? `✓ ${imagenPDF.name}` : 'Opcional — no se guarda en la base de datos'}
                    </div>
                  </div>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                  <label style={{ padding:'5px 12px', background:'#fff', border:'1px solid #87B749', borderRadius:'7px', fontSize:'12px', color:'#3B6D11', fontWeight:'600', cursor:'pointer', whiteSpace:'nowrap' }}>
                    {imagenPDF ? 'Cambiar imagen' : '+ Adjuntar imagen'}
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display:'none' }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;
                        const reader = new FileReader();
                        reader.onload = (ev) => {
                          const img = new Image();
                          img.onload = () => {
                            const MAX = 1600;
                            const ratio = img.naturalWidth / img.naturalHeight;
                            let w = img.naturalWidth;
                            let h = img.naturalHeight;
                            if (w >= h && w > MAX) { w = MAX; h = Math.round(MAX / ratio); }
                            else if (h > w && h > MAX) { h = MAX; w = Math.round(MAX * ratio); }
                            const canvas = document.createElement('canvas');
                            canvas.width = w;
                            canvas.height = h;
                            const ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0, w, h);
                            const jpegDataUrl = canvas.toDataURL('image/jpeg', 0.82);
                            setImagenPDF({ dataUrl: jpegDataUrl, name: file.name, format: 'JPEG' });
                          };
                          img.src = ev.target.result;
                        };
                        reader.readAsDataURL(file);
                      }}
                    />
                  </label>
                  {imagenPDF && (
                    <button
                      onClick={() => setImagenPDF(null)}
                      title="Quitar imagen"
                      style={{ padding:'5px 10px', background:'none', border:'1px solid #fcc', borderRadius:'7px', fontSize:'12px', color:'#A32D2D', cursor:'pointer' }}>
                      Quitar
                    </button>
                  )}
                </div>
              </div>

              {hrSep()}

              {/* Info general */}
              <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'12px' }}>Información general</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'14px 24px' }}>
                {campoVer('Tipo de servicio',  detalle.tipo_servicio_oferta)}
                {campoVer('Moneda',           detalle.moneda)}
                {campoVer('Facturar con',     detalle.facturar_con)}
                {campoVer('Fecha oferta',     formatFecha(detalle.fecha_oferta))}
                {campoVer('Vigencia',         detalle.vigencia_dias ? `${detalle.vigencia_dias} días` : null)}
                {campoVer('Vencimiento',      formatFecha(detalle.fecha_vencimiento))}
                <div style={{ gridColumn:'1/-1' }}>{campoVer('Descripción', detalle.descripcion_general)}</div>
              </div>

              {hrSep()}

              {/* Cliente y contacto */}
              <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'12px' }}>Cliente y contacto</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'14px 24px' }}>
                {campoVer('Cliente',          detalle.cliente_nombre)}
                {campoVer('Contacto',         detalle.nombre_contacto)}
                {campoVer('Teléfono',         detalle.telefono_contacto)}
                <div style={{ gridColumn:'1/-1' }}>{campoVer('Correo', detalle.correo_contacto)}</div>
              </div>

              {hrSep()}

              {/* Ubicación */}
              <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'12px' }}>Ubicación</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:'14px 24px' }}>
                {campoVer('Provincia', detalle.provincia)}
                {campoVer('Cantón',    detalle.canton)}
                {campoVer('Distrito',  detalle.distrito)}
                <div style={{ gridColumn:'1/-1' }}>{campoVer('Dirección', detalle.direccion)}</div>
              </div>

              {/* Servicios */}
              {detalle.servicios && detalle.servicios.length > 0 && (
                <>
                  {hrSep()}
                  <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'10px' }}>Servicios incluidos</div>
                  <div style={{ display:'flex', flexWrap:'wrap', gap:'6px' }}>
                    {detalle.servicios.map(srv => (
                      <span key={srv} style={{ background:'#eaf3de', color:'#3B6D11', padding:'3px 10px', borderRadius:99, fontSize:'12px', fontWeight:'500' }}>{srv}</span>
                    ))}
                  </div>
                </>
              )}

              {/* Líneas de honorarios */}
              {detalle.lineas && detalle.lineas.length > 0 && (
                <>
                  {hrSep()}
                  <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'12px' }}>Líneas de honorarios</div>
                  <div style={{ border:'1px solid #e8e8e8', borderRadius:'10px', overflow:'hidden', marginBottom:'10px' }}>
                    <div style={{ background:'#f8f9fa', padding:'9px 14px', display:'grid', gridTemplateColumns:'28px 1fr 110px 70px 110px', gap:'12px', alignItems:'center', borderBottom:'1px solid #eee' }}>
                      {['#','Descripción','Monto','IVA','Total c/IVA'].map(h => (
                        <div key={h} style={{ fontSize:'11px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', textAlign: h==='Monto'||h==='Total c/IVA'?'right':'left' }}>{h}</div>
                      ))}
                    </div>
                    {detalle.lineas.map(l => (
                      <div key={l.id} style={{ padding:'10px 14px', borderBottom:'1px solid #f5f5f5', display:'grid', gridTemplateColumns:'28px 1fr 110px 70px 110px', gap:'12px', alignItems:'center' }}>
                        <div style={{ fontSize:'12px', color:'#aaa', fontWeight:'600' }}>{l.numero_linea}</div>
                        <div>
                          <div style={{ fontSize:'13px', fontWeight:'600', color:'#1a1a1a' }}>{l.descripcion_corta}</div>
                          {l.descripcion_larga && <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{l.descripcion_larga}</div>}
                          {l.hitos && l.hitos.length > 0 && (
                            <div style={{ fontSize:'11px', color:'#888', marginTop:'3px' }}>
                              Hitos: {l.hitos.map(h => `${h.nombre_hito} (${h.porcentaje}%)`).join(' · ')}
                            </div>
                          )}
                          {l.es_recurrente && <div style={{ fontSize:'11px', color:'#854F0B', marginTop:'2px' }}>Tarifa por {l.unidad || 'unidad'}</div>}
                        </div>
                        <div style={{ fontSize:'13px', color:'#012E40', fontWeight:'500', textAlign:'right' }}>{fmt(l.monto)}</div>
                        <div style={{ textAlign:'center' }}>
                          {l.exonerado
                            ? <span style={{ background:'#eaf3de', color:'#3B6D11', padding:'2px 7px', borderRadius:'6px', fontSize:'11px', fontWeight:'500' }}>Exo.</span>
                            : <span style={{ background:'#faeeda', color:'#854F0B', padding:'2px 7px', borderRadius:'6px', fontSize:'11px', fontWeight:'500' }}>13%</span>}
                        </div>
                        <div style={{ fontSize:'13px', color:'#012E40', fontWeight:'700', textAlign:'right' }}>
                          {fmt(l.exonerado ? parseFloat(l.monto) : parseFloat(l.monto) * 1.13)}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Totales */}
                  {(() => {
                    const tot = calcTotales(detalle.lineas);
                    return (
                      <div style={{ background:'#f8f9fa', border:'1px solid #eee', borderRadius:'10px', padding:'14px 18px', display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'12px' }}>
                        <div>
                          <div style={{ fontSize:'10px', color:'#aaa', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'3px' }}>Subtotal</div>
                          <div style={{ fontSize:'14px', fontWeight:'600', color:'#333' }}>{fmt(tot.sub)} {detalle.moneda}</div>
                        </div>
                        <div>
                          <div style={{ fontSize:'10px', color:'#aaa', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'3px' }}>IVA 13%</div>
                          <div style={{ fontSize:'14px', fontWeight:'600', color:'#854F0B' }}>{fmt(tot.iva)} {detalle.moneda}</div>
                        </div>
                        <div>
                          <div style={{ fontSize:'10px', color:'#aaa', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'3px' }}>Total oferta</div>
                          <div style={{ fontSize:'18px', fontWeight:'700', color:'#012E40' }}>{fmt(tot.total)} {detalle.moneda}</div>
                        </div>
                      </div>
                    );
                  })()}
                </>
              )}

              {/* Condiciones generales */}
              {detalle.condiciones_generales && (
                <>
                  {hrSep()}
                  <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:'8px' }}>Condiciones generales</div>
                  <div style={{ padding:'10px 14px', background:'#fff8e1', borderRadius:'8px', fontSize:'13px', color:'#555', border:'1px solid #ffe082', lineHeight:'1.6' }}>
                    {detalle.condiciones_generales}
                  </div>
                </>
              )}

            </div>
          </div>
        </div>
      )}

      {/* ── Modal formulario ── */}
      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:'20px' }}>
          <div style={{ background:'#fff', borderRadius:'16px', width:'100%', maxWidth:'860px', maxHeight:'90vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>

            {/* Header limpio */}
            <div style={{ padding:'20px 24px 16px', borderBottom:'1px solid #eee', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
              <div>
                <div style={{ fontSize:'17px', fontWeight:'700', color:'#012E40' }}>{editando ? 'Editar oferta' : 'Nueva oferta a cliente'}</div>
                <div style={{ fontSize:'12px', color:'#888', marginTop:'3px' }}>Completá los datos de la oferta y sus líneas de honorarios</div>
              </div>
              <button onClick={() => setModal(false)} style={{ background:'none', border:'none', fontSize:'22px', cursor:'pointer', color:'#aaa', lineHeight:1 }}>✕</button>
            </div>

            {/* Cuerpo scrolleable */}
            <div style={{ overflowY:'auto', padding:'24px', display:'flex', flexDirection:'column', gap:'4px' }}>

              {error && (
                <div style={{ background:'#FCEBEB', border:'1px solid #f5c6c6', borderRadius:'8px', padding:'10px 14px', fontSize:'13px', color:'#A32D2D', marginBottom:'8px' }}>
                  {error}
                </div>
              )}

              {cobrosLigados.tiene && (
                <div style={{ background:'#E8F0F2', borderLeft:'4px solid #012E40', borderRadius:'6px', padding:'12px 16px', fontSize:'13px', color:'#012E40', marginBottom:'10px' }}>
                  <div style={{ fontWeight:'700', marginBottom:'4px' }}>Edicion limitada</div>
                  <div style={{ lineHeight:'1.5' }}>
                    Esta oferta tiene <strong>{cobrosLigados.count} cobro{cobrosLigados.count !== 1 ? 's' : ''}</strong> generado{cobrosLigados.count !== 1 ? 's' : ''} ligado{cobrosLigados.count !== 1 ? 's' : ''}. Para proteger la integridad de los cobros, los montos, la exoneracion y los hitos de cobro estan bloqueados. Si puedes editar la cabecera (cliente, contacto, fechas, direccion) y, dentro de cada linea, el <strong>subcontrato</strong> y el <strong>presupuesto interno</strong>. Para cambiar montos o hitos, primero anula o elimina los cobros asociados.
                  </div>
                </div>
              )}

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>

                {seccion('Identificación')}
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>N° OFS (ID Proyecto) *</label>
                  <input style={{ ...inputStyle, borderColor:ofsError?'#e74c3c':'#e0e0e0' }}
                    value={form.numero_ofs}
                    onChange={e => { setF('numero_ofs', e.target.value); setOfsError(''); }}
                    onBlur={e => validarOfs(e.target.value)}
                    placeholder="Ej: 208-00" />
                  {ofsError && <div style={{ fontSize:'11px', color:'#A32D2D', marginTop:'3px' }}>{ofsError}</div>}
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Fecha de oferta</label>
                  <input type="date" style={inputStyle} value={form.fecha_oferta || ''} onChange={e => setF('fecha_oferta', e.target.value)} />
                </div>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Nombre del proyecto *</label>
                  <input style={inputStyle} value={form.nombre_proyecto} onChange={e => setF('nombre_proyecto', e.target.value)} placeholder="Nombre descriptivo del proyecto" />
                </div>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Descripción general</label>
                  <textarea style={{ ...inputStyle, minHeight:'65px', resize:'vertical' }} value={form.descripcion_general} onChange={e => setF('descripcion_general', e.target.value)} placeholder="Párrafo introductorio para la oferta al cliente..." />
                </div>

                {seccion('Configuración')}
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Facturar con *</label>
                  <select style={{ ...inputStyle, background:'#fff' }} value={form.facturar_con} onChange={e => setF('facturar_con', e.target.value)}>
                    {EMPRESAS.map(e => <option key={e}>{e}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Estado</label>
                  <select style={{ ...inputStyle, background:'#fff' }} value={form.estado} onChange={e => setF('estado', e.target.value)}>
                    {ESTADOS.map(e => <option key={e}>{e}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Tipo de servicio</label>
                  <select style={{ ...inputStyle, background:'#fff' }} value={form.tipo_servicio_oferta} onChange={e => setF('tipo_servicio_oferta', e.target.value)}>
                    <option value="">— Seleccionar —</option>
                    {tiposServicio.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Moneda</label>
                  <select style={{ ...inputStyle, background:'#fff' }} value={form.moneda} onChange={e => setF('moneda', e.target.value)}>
                    <option>Dólares</option><option>Colones</option>
                  </select>
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Vigencia (días)</label>
                  <input type="number" style={inputStyle} value={form.vigencia_dias} min="1"
                    onChange={e => setF('vigencia_dias', e.target.value)} />
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Fecha de vencimiento</label>
                  <input type="date" style={inputStyle} value={form.fecha_vencimiento || ''}
                    onChange={e => setForm(f => ({ ...f, fecha_vencimiento: e.target.value }))} />
                </div>

                {seccion('Cliente')}
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Cliente</label>
                  <select style={{ ...inputStyle, background:'#fff' }} value={form.cliente_id} onChange={e => fillCliente(e.target.value)}>
                    <option value="">— Seleccionar cliente —</option>
                    {clientes.map(c => <option key={c.id} value={c.id}>{c.id_cliente} — {c.nombre}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Nombre del contacto</label>
                  <input style={inputStyle} value={form.nombre_contacto} onChange={e => setF('nombre_contacto', e.target.value)} placeholder="Se carga desde el cliente" />
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Teléfono del contacto</label>
                  <input style={inputStyle} value={form.telefono_contacto} onChange={e => setF('telefono_contacto', e.target.value)} placeholder="8888-8888" />
                </div>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Correo del contacto</label>
                  <input type="email" style={inputStyle} value={form.correo_contacto} onChange={e => setF('correo_contacto', e.target.value)} placeholder="contacto@cliente.com" />
                </div>

                {seccion('Ubicación del proyecto')}
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Provincia</label>
                  <select style={{ ...inputStyle, background:'#fff' }} value={form.provincia} onChange={e => setF('provincia', e.target.value)}>
                    {PROVINCIAS.map(p => <option key={p}>{p}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Cantón</label>
                  <input style={inputStyle} value={form.canton} onChange={e => setF('canton', e.target.value)} placeholder="Cantón" />
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Distrito</label>
                  <input style={inputStyle} value={form.distrito} onChange={e => setF('distrito', e.target.value)} placeholder="Distrito" />
                </div>
                <div>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Dirección exacta</label>
                  <input style={inputStyle} value={form.direccion} onChange={e => setF('direccion', e.target.value)} placeholder="Dirección completa" />
                </div>

                {seccion('Servicios cotizados')}
                <div style={{ gridColumn:'1/-1', display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'4px 16px' }}>
                  {SERVICIOS_CATS.map(cat => (
                    <div key={cat.cat}>
                      <div style={{ fontSize:'11px', fontWeight:'700', color:'#012E40', margin:'8px 0 3px', textTransform:'uppercase', letterSpacing:'0.04em' }}>{cat.cat}</div>
                      {cat.items.map(item => (
                        <label key={item} style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'12px', color:'#333', padding:'2px 0', cursor:'pointer' }}>
                          <input type="checkbox" checked={form.servicios.includes(item)}
                            onChange={() => toggleServicio(item)}
                            style={{ width:'13px', height:'13px', accentColor:'#87B749', flexShrink:0 }} />
                          {item}
                        </label>
                      ))}
                    </div>
                  ))}
                </div>

                {seccion('Honorarios profesionales')}
                <div style={{ gridColumn:'1/-1' }}>
                  <div>
                    {form.lineas.map((l, i) => renderLinea(l, i))}
                    {!cobrosLigados.tiene && (
                      <button onClick={addLinea} style={{ width:'100%', marginTop:'4px', border:'1px dashed #ccc', background:'none', borderRadius:'8px', padding:'8px', fontSize:'12px', cursor:'pointer', color:'#888' }}>
                        + Agregar item
                      </button>
                    )}
                  </div>
                  <div style={{ marginTop:'10px', padding:'12px 14px', background:'#f8f9fa', borderRadius:'8px', fontSize:'12px' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', color:'#666', marginBottom:'4px' }}><span>Subtotal</span><span>{fmt(t.sub)}</span></div>
                    {t.exo > 0 && <div style={{ display:'flex', justifyContent:'space-between', color:'#3B6D11', marginBottom:'4px' }}><span>Exonerado</span><span>{fmt(t.exo)}</span></div>}
                    <div style={{ display:'flex', justifyContent:'space-between', color:'#854F0B', marginBottom:'4px' }}><span>IVA 13% (base gravada: {fmt(t.grav)})</span><span>{fmt(t.iva)}</span></div>
                    <div style={{ display:'flex', justifyContent:'space-between', fontWeight:'600', fontSize:'14px', color:'#012E40', borderTop:'1px solid #ddd', paddingTop:'6px' }}><span>Total</span><span>{fmt(t.total)} {form.moneda}</span></div>
                  </div>
                </div>

                {seccion('Condiciones generales')}
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={{ fontSize:'10px', color:'#888', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px', display:'block' }}>Condiciones generales de la oferta (pie del PDF)</label>
                  <textarea style={{ ...inputStyle, minHeight:'80px', resize:'vertical' }} value={form.condiciones_generales}
                    onChange={e => setF('condiciones_generales', e.target.value)}
                    placeholder="Vigencia de la oferta, condiciones de pago, exclusiones..." />
                </div>

                <div style={{ gridColumn:'1/-1', display:'flex', gap:'8px', padding:'10px 12px', background:'#E6F1FB', borderRadius:'8px', border:'1px solid #B5D4F4', fontSize:'12px', color:'#185FA5', alignItems:'flex-start' }}>
                  <svg width="16" height="16" viewBox="0 0 20 20" fill="none" style={{ flexShrink:0, marginTop:'1px' }}>
                    <circle cx="10" cy="10" r="8.5" stroke="#185FA5" strokeWidth="1.4"/>
                    <path d="M10 9v5M10 7v.5" stroke="#185FA5" strokeWidth="1.6" strokeLinecap="round"/>
                  </svg>
                  <span>La oferta se guarda sin crear proyecto. El proyecto se genera automáticamente al <strong>Aprobar</strong> la oferta.</span>
                </div>

              </div>
            </div>

            {/* Footer */}
            <div style={{ padding:'16px 24px', borderTop:'1px solid #eee', display:'flex', justifyContent:'flex-end', gap:'10px', flexShrink:0 }}>
              <button onClick={() => setModal(false)} style={{ padding:'9px 20px', border:'1px solid #e0e0e0', borderRadius:'8px', background:'#fff', cursor:'pointer', fontSize:'13px', color:'#555' }}>
                Cancelar
              </button>
              <button onClick={guardar} style={{ padding:'9px 24px', background:'#012E40', color:'#fff', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>
                {editando ? 'Guardar cambios' : 'Crear oferta'}
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ── Modal eliminar ── */}
      {modalEliminar && (
        <ModalEliminar
          titulo="Eliminar oferta"
          descripcion={`${modalEliminar.numero_ofs} — ${modalEliminar.nombre_proyecto}`}
          onConfirm={confirmarEliminar}
          onCancel={() => setModalEliminar(null)}
        />
      )}

      {/* ── Modal aprobar ── */}
      {modalAprobar && (
        <ModalAprobar
          oferta={modalAprobar}
          proyectoPrevio={proyectoPrevio}
          cargandoPrevio={cargandoProyPrevio}
          aprobando={aprobando}
          onConfirm={confirmarAprobar}
          onCancel={() => { if (!aprobando) setModalAprobar(null); }}
        />
      )}

      {genProy && (
        <ModalGenerarProyecciones
          ofertaId={genProy.ofertaId}
          proyectoId={genProy.proyectoId}
          moneda={genProy.moneda}
          facturarCon={genProy.facturarCon}
          obligatorio
          onCerrar={() => setGenProy(null)}
          onGenerado={() => { setGenProy(null); cargar(); }}
        />
      )}

    </div>
  );
}
